import React, { useEffect, useMemo, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useHistory, useParams } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import Calender from "../../assets/icons/Calendar with interaction.svg";
import Clipboard from "../../assets/icons/clipboard.svg";
import whitePen from "../../assets/icons/edit-3.svg";
import searchIcon from "../../assets/icons/search.svg";
import send from "../../assets/icons/send.svg";
import x from "../../assets/icons/x-circle.svg";
import xcircle3 from "../../assets/icons/x-circle-3.svg";
import xIcon from "../../assets/icons/x-circle.svg";
import stopCircle from "../../assets/icons/stop-circle2.svg";
import proEquipmentsIcon from "../../assets/icons/proEquipmentsIcon.svg";
import "../../assets/styles/local/TaskMain.css";
import "../../assets/styles/local/contactTaskPopup.css";
import "../../assets/styles/local/AddTaskModal.css";
import { getLocalFormatedTime } from "../../utils/helpers/calculateTime";
import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import moment from "moment";
import { BsChevronDown, BsPlusLg } from "react-icons/bs";
import { FiSearch } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import bell from "../../assets/icons/Bell.svg";
import deleteIcon from "../../assets/icons/Bin.svg";
import editIcon from "../../assets/icons/edit-2.svg";
import statusicon from "../../assets/icons/Checked.svg";
import invoice from "../../assets/icons/Invoice.svg";
import invoiceBlack from "../../assets/icons/InvoiceBlack.svg";
import Clock from "../../assets/icons/Clock Icon.svg";
import PriorityIcon from "../../assets/icons/Group 2752.svg";
import PlusIcon from "../../assets/icons/Group 2946.svg";
import Timer from "../../assets/icons/TimerBlack.svg";
import Stop from "../../assets/icons/stop-circle.svg";
import Triangle from "../../assets/icons/triangle.svg";
import TriangleLight from "../../assets/icons/triangleLight.svg";
import user from "../../assets/icons/user.svg";
import Icon2 from "../../assets/images/Group 354.svg";
import PlusIcon2 from "../../assets/images/Plus.svg";
import { GetPOById } from "../../redux/actions/proformaAction";
import { Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";
import LogoSmall from "../../assets/images/logo-small.png";
import floatingSound from "../../assets/audios/floating-notification-tone.wav";
import layer from "../../assets/icons/layers2.svg";
import threeDots from "../../assets/icons/Kebab Calculations.svg";
import duplicateIcon from "../../assets/icons/Duplicate blur.svg";
import shareIcon from "../../assets/icons/share-2.svg";
import xCircleMainIcon from "../../assets/icons/x-circle-2.svg";
import Linkify from "react-linkify";
import LinkifyIt from "linkify-it";
import html2canvas from "html2canvas";

import {
  AddComments,
  CheckIfTimeSessionStartOrNot,
  CreateNewTimeSession,
  FetchActiveUsers,
  FetchTaskByProject,
  GetActiveTimeSessionOnPlanboard,
  GetTimeSession,
  ProjectDropdown,
  UpdateTimeSession,
  addCheckList,
  addTask,
  deleteChecklist,
  fetchProjectByCompany,
  fetchTask,
  fetchTaskByCompanyId,
  fetchUsersByCompany,
  updateTask,
  ChangeStatus,
  updateTaskIndex,
  deleteTaskIdFromTimer,
  setCheckTimeSessionToFalse,
  GlobalRequest,
  DeleteComments,
  AddContact,
  emptyTaskState,
  fetchFormById,
  UpdateTaskDescription,
  UpdateTaskAssigee,
  RemoveTaskAssigee,
  UpdateEstimatedTime,
  CreateInvoice,
  FetchLastInvoiceCode,
} from "../../redux/actions/action";
// import Testing from "./Test";
import axios from "axios";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import {
  API_URL,
  ADD_TASK,
  ADD_COMM,
  TASK_MODAL_COMMENT_DELETE,
} from "../../redux/constants/type";
import { handleGeneralNotification } from "../../utils/helpers/notifications";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import AppDatePicker from "../Common/AppDatePicker";
// import Test from "./Test";
import { useLocation } from "react-router-dom";
import DocumentUploaderWithProgress from "../Common/Document_Uploader_With_Progress";
import Checkbox from "@mui/material/Checkbox";
import CircleOutlinedIcon from "@mui/icons-material/CircleOutlined";
import CircleIcon from "@mui/icons-material/Circle";
import { GetCompletedTask } from "../../redux/actions/proformaAction";
import trash from "../../assets/icons/DeleteIcon.svg";
import { Editor } from "react-draft-wysiwyg";
import {
  RichUtils,
  convertToRaw,
  EditorState,
  convertFromRaw,
  Modifier,
  ContentState,
} from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import parse from "html-react-parser";
import Loader from "./Loader";
import TaskEquipmentList from "./TaskEquipmentList";
import AssigneeModal from "../TaskFilter/AssigneeModal";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { geocodeByPlaceId } from "react-google-places-autocomplete";
import TaskDelete from "../../components/Dailogs/TaskDelete";
import simpleRequest from "../../utils/helpers/simpleRequest";
import { formatDateTime } from "../../utils/timeZone/formatDateTime";
import {
  Checklist,
  Dependency,
  Attachments,
  AddForm,
  Activity,
  TaskProductsPart,
} from "../Planboard";

const normalizeTaskDescriptionLists = (html = "") => {
  const doc = new DOMParser().parseFromString(html, "text/html");

  // Remove empty paragraphs/divs inside list items
  doc.querySelectorAll("li").forEach((li) => {
    li.querySelectorAll("p, div").forEach((element) => {
      element.replaceWith(...Array.from(element.childNodes));
    });
  });

  return doc.body.innerHTML;
};

const AddTaskModal = (props) => {
  const { taskId } = useParams();
  const { id } = useParams();
  const rowClickRef = useRef([]);
  const taskResponseWasClearedRef = useRef(false);
  const [isTaskLoading, setIsTaskLoading] = useState(
    props.modalFunction === "update" ||
      props.modalFunctionNoty === "Notification",
  );
  const userID = window.localStorage.getItem("userid");
  const userimag = window.localStorage.getItem("userimageurl");

  // let disableMSGsend = props.maxComments
  // let disableMSGsend = props.maxComments.length === 0;

  const [openAssigneeModal, setOpenAssigneeModal] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [changeStateForPO, SetchangeStateForPO] = useState(false);
  const [fetchAddTask, setFetchAddTask] = useState({});
  const tt = (key) => fetchAddTask?.[key] || "";
  const [fetchTransUpdateTaskList, setFetchTransUpdateTaskList] = useState({});
  const t = (key) => fetchTransUpdateTaskList?.[key] || "";
  const location = useLocation();
  const taskSearchRef = useRef(null);
  const inputRef = useRef(null);
  const inputRef2 = useRef(null);
  const projectSearchRef = useRef(null);
  const assigneeDropdownRef = useRef(null);
  const statusDropdownRef = useRef(null);
  const sectionDropdownRef = useRef(null);
  const priorityDropdownRef = useRef(null);
  const duplicateDropdownRef = useRef(null);
  const notificationDropdownRef = useRef(null);
  const dependenciesRef = useRef(null);
  const dependenciesRefExclude = useRef(null);
  const modalRef = useRef(null);
  const history = useHistory();
  const dispatch = useDispatch();
  const [disabled, setDisabled] = useState(false);

  const roleAccess = window.localStorage.getItem("roleid");
  const userlastname = window.localStorage.getItem("lastname");
  const userfirstname = window.localStorage.getItem("firstname");
  const companyId = window.localStorage.getItem("companyid");
  const userId = window.localStorage.getItem("userid");

  const [title, setTitle] = useState("");
  const [clientSearch, setClientSearch] = useState("");
  const [projectSearch, setProjectSearch] = useState("");
  const [searchPeople, setSearchPeople] = useState("");
  const [description, setDescription] = useState("");
  const [workAddress, setWorkAddress] = useState("");
  const [pinCodeForAdress, setPinCodeForAdress] = useState("");
  const [dueDate, setDueDate] = useState(new Date());
  const [startDate, setStartDate] = useState(new Date());
  const [hours, setHours] = useState("");
  const [minutes, setMinutes] = useState("");
  const [nminutes, setNMinutes] = useState(); //Don’t
  const [notiTime, setNotiTime] = useState(); //notify
  const notificationTimes = [
    tt("15 Minutes"),
    tt("30 Minutes"),
    tt("1 Hour"),
    tt("24  Hour"),
    tt("notify") + " " + tt("Don't "),
  ];
  const [openInvoice, setOpenInvoice] = useState(false);
  const [addWorkPopup, setAddWorkPopup] = useState(false);
  const [workCompletedSearch, setWorkCompletedSearch] = useState("");

  useEffect(() => {
    fetchScreenTranslations("Add-Task").then((res) => {
      setFetchAddTask(res);
      setNotiTime(res[57]?.translation ? res[57]?.translation : "notify");
      setNMinutes(res[58]?.translation ? res[58]?.translation : "Don’t");
    });
    fetchScreenTranslations("Updated-Task").then((res) => {
      setFetchTransUpdateTaskList(res);
    });
  }, []);

  const [estimatedTime, setEstimatedTime] = useState("0");
  const [statusData, setStatusData] = useState([]);
  const [statusId, setStatusId] = useState("");
  const [sectionId, setSectionId] = useState("");
  const [sectionName, setSectionName] = useState("");
  const [priorityId, setPriorityId] = useState("");
  const [priorityName, setPriorityName] = useState("");
  const [priorityData, setPriorityData] = useState([]);
  const [statusName, setStatusName] = useState("");
  const [voucherCreated, setVoucherCreated] = useState(false);
  const [invoiceCreated, setInvoiceCreated] = useState(false);
  const [voucher, setVoucher] = useState({});
  const [showNotiDropDown, setShowNotiDropDown] = useState(false);
  const [client, setClient] = useState(null);
  const [project, setProject] = useState(null);
  const [mainProjectList, setMainProjectList] = useState([]);
  const [fullMainProjectList, setFullMainProjectList] = useState([]);
  const [company, setCompany] = useState(null);
  const [showClientDrop, setShowClientDrop] = useState(false);
  const [showProjectDrop, setShowProjectDrop] = useState(false);
  const [showDependencyDrop, setShowDependencyDrop] = useState(false);
  const [showDropPeople, setShowDropPeople] = useState(false);
  const [showStatusDrop, setShowStatusDrop] = useState(false);
  const [showSectionDrop, setShowSectionDrop] = useState(false);
  const [showPriorityDrop, setShowPriorityDrop] = useState(false);
  const [isTimerRunning, setIsTimerRunning] = useState(false);
  const [projectList, setProjectList] = useState([]);
  const [fullProjectList, setFullProjectList] = useState([]);
  const [docPeopleList, setDocPeopleList] = useState([]);
  const [fullDocPeopleList, setFullDocPeopleList] = useState([]);
  const [fullDocPeopleList2, setFullDocPeopleList2] = useState([]);
  const [dependencyList, setDependencyList] = useState([]);
  const [selectedEquipments, setSelectedEquipments] = useState([]);
  const [activityEquipments, setActivityEquipments] = useState([]);
  const [activityData, setActivityData] = useState([]);
  const [toggleEquipment, setToggleEquipment] = useState(false);
  const [allTasks, setAllTasks] = useState([]);
  const [checklist, setChecklist] = useState([]);
  const [showError, setShowError] = useState(false);
  const [showError2, setShowError2] = useState(false);
  const [showAddItem, setShowAddItem] = useState(false);
  const [cancel, setCancel] = useState(false);
  const [checklistTitle, setChecklistTitle] = useState("");
  const [playColor, setPlayColor] = useState("");
  const [totalCheck, setTotalCheck] = useState("");
  const [check, setCheck] = useState("");
  const [percent, setPercent] = useState("");
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [choose, setChoose] = useState("");
  const [chooselast, setChooselast] = useState("");
  const [activeuser, setActiveuser] = useState([]);
  const [sectionList, setSectionList] = useState([]);
  const [showDropPeopleComm, setShowDropPeopleComm] = useState(false);
  const [selectedAssignee, setSelectedAssignee] = useState([]);
  const [session1, setSession1] = useState("00");
  const [session2, setSession2] = useState("00");
  const [session3, setSession3] = useState("00");
  const [total1, setTotal1] = useState("00");
  const [total2, setTotal2] = useState("00");
  const [taskComplete, setTaskComplete] = useState(false);
  const [taskTrackingId, setTaskTrackingId] = useState("");
  const [disableTracking, setDisableTracking] = useState(true);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [isActiveDuplicate, setIsActiveDuplicate] = useState(false);

  const fetchProjectsResponse = useSelector(
    (state) => state.user.fetchProjectDropdown,
  );
  const projectListData = useSelector(
    (state) => state.user.fetchCompanyProjectData,
  );
  const fetchTasksResponse = useSelector(
    (state) => state.user.fetchTasksResponse,
  );
  const fetchTaskResponse = useSelector(
    (state) => state.user.fetchTaskResponse,
  );
  const addTaskResponse = useSelector((state) => state.user.addTaskResponse);
  const updateTaskResponse = useSelector(
    (state) => state.user.updateTaskResponse,
  );
  const activeStatusResponse = useSelector(
    (state) => state.user.activeStatusResponse,
  );
  const addChecklistResponse = useSelector(
    (state) => state.user.addChecklistResponse,
  );
  const deleteChecklistResponse = useSelector(
    (state) => state.user.deleteChecklistResponse,
  );
  const fetchUsersByCompanyResponse = useSelector(
    (state) => state.user.fetchUsersByCompany,
  );
  const fetchAppSideNavOptions = useSelector(
    (state) => state.user.appSideNavOptions,
  );
  const getSectionsListRes = useSelector(
    (state) => state.user.getSectionsListRes,
  );
  const CheckIfTimeSessionStartOrNotResponse = useSelector(
    (state) => state.user.CheckIfTimeSessionStartOrNotResponse,
  );
  const GetActiveTimeSessionOnPlanboardResponse = useSelector(
    (state) => state.user.GetActiveTimeSessionOnPlanboardResponse,
  );
  const CreateNewTimeSessionResponse = useSelector(
    (state) => state.user.CreateNewTimeSessionResponse,
  );
  const GetTimeSessionResponse = useSelector(
    (state) => state.user.GetTimeSessionResponse,
  );
  const UpdateTimeSessionResponse = useSelector(
    (state) => state.user.UpdateTimeSessionResponse,
  );
  const StopTimerFromHeaderResponse = useSelector(
    (state) => state.user.StopTimerFromHeaderResponse,
  );

  const taskModalCommentDeleteRes = useSelector(
    (state) => state.user.taskModalCommentDeleteRes,
  );

  const addCommentsRes = useSelector((state) => state.user.addComments);

  const addDocumentToTaskRes = useSelector(
    (state) => state.user.addDocumentToTaskRes,
  );

  const addTaskDescriptionRes = useSelector(
    (state) => state.user.addTaskDescriptionRes,
  );

  const updateTaskAssigneeApiRes = useSelector(
    (state) => state.user.updateTaskAssigneeApiRes,
  );

  const removeTaskAssigneeRes = useSelector(
    (state) => state.user.removeTaskAssigneeRes,
  );

  const assigneeLocalDataRes = useSelector(
    (state) => state.user.assigneeLocalDataRes,
  );

  const fetchLastInvoiceCodeRes = useSelector(
    (state) => state.user.fetchLastInvoiceCodeRes,
  );

  const [selectedLocalUsers, setSelectedLocalUsers] = useState([]);
  const selectedUsersRef = useRef([]);
  const checklistAssigneeIdsRef = useRef(new Set());
  const manualTaskAssigneeIdsRef = useRef(new Set());
  const checklistSyncedTaskAssigneeIdsRef = useRef(new Set());

  useEffect(() => {
    selectedUsersRef.current = selectedUsers;
  }, [selectedUsers]);

  const getAssigneeId = (assignee = {}) =>
    assignee.assigneeid || assignee.userid || assignee.id;

  const dedupeAssigneesById = (assignees = []) => {
    return Array.from(
      new Map(
        assignees
          .filter((assignee) => getAssigneeId(assignee))
          .map((assignee) => [
            getAssigneeId(assignee),
            {
              ...assignee,
              assigneeid: getAssigneeId(assignee),
            },
          ]),
      ).values(),
    );
  };

  const getChecklistTaskAssignees = (taskChecklist = []) => {
    const checklistAssignees = taskChecklist.flatMap((checklistItem) =>
      (checklistItem?.checklistitem || []).flatMap(
        (item) => item?.checklistitemassignees || [],
      ),
    );

    return dedupeAssigneesById(
      checklistAssignees.map((assignee) => ({
        ...assignee,
        assigneeid: getAssigneeId(assignee),
        userid: getAssigneeId(assignee),
        firstname:
          assignee.firstname || assignee.assigneename || assignee.firstName,
        lastname: assignee.lastname || assignee.lastName || "",
        imageurl: assignee.imageurl || assignee.assigneeimage || "",
        type: assignee.type || "user",
      })),
    );
  };

  const buildTaskAssigneePayload = () => {
    const currentAssignees = selectedUsersRef.current?.length
      ? selectedUsersRef.current
      : selectedUsers;

    return dedupeAssigneesById([
      ...currentAssignees,
      ...getChecklistTaskAssignees(checklist),
    ])
      .filter((assignee) => assignee.type !== "team-user")
      .map((assignee) => ({
        assigneeid: getAssigneeId(assignee),
        type: assignee?.type === "single" ? "user" : (assignee?.type ?? "user"),
      }));
  };

  const syncExistingTaskAssignees = (assigneeMain) => {
    if (!props.taskid) return;

    dispatch(
      UpdateTaskAssigee({
        taskid: props.taskid,
        taskassignee: Array.from(
          new Set(assigneeMain.map((assignee) => assignee.assigneeid)),
        ).map((assigneeid) => ({ assigneeid })),
      }),
    );
  };

  useEffect(() => {
    if (assigneeLocalDataRes?.assigneeData) {
      const data = assigneeLocalDataRes?.assigneeData?.map((x) => ({
        ...x,
        // assigneeid: x.id,
        // firstname: x.firstName,
        // lastname: x.lastName,
      }));
      data.forEach((x) => {
        x.firstname = x.firstName;
        x.lastname = x.lastName;
        delete x.firstName; // optional
        delete x.lastName; // optional
      });
      // setSelectedUsers(data);
      console.log("asc55 local", data);
    }
  }, [assigneeLocalDataRes]);

  useEffect(() => {
    if (assigneeLocalDataRes?.assigneeData?.length) {
      setSelectedLocalUsers((prev) => {
        const merged = [...prev, ...assigneeLocalDataRes.assigneeData];

        return merged.filter(
          (user, index, self) =>
            index ===
            self.findIndex(
              (u) => (u.id || u.assigneeid) === (user.id || user.assigneeid),
            ),
        );
      });
    }
  }, [assigneeLocalDataRes]);

  // auto update assigness in main task start
  useEffect(() => {
    const checklistAssignees = getChecklistTaskAssignees(checklist);
    const checklistAssigneeIds = new Set(
      checklistAssignees.map((assignee) => getAssigneeId(assignee)),
    );
    checklistAssigneeIdsRef.current = checklistAssigneeIds;
    const currentTaskAssignees = selectedUsersRef.current || [];
    const currentTaskAssigneeIds = new Set(
      currentTaskAssignees.map((assignee) => getAssigneeId(assignee)),
    );
    const assigneesToAdd = checklistAssignees.filter(
      (assignee) => !currentTaskAssigneeIds.has(getAssigneeId(assignee)),
    );
    const assigneeIdsToAdd = assigneesToAdd.map((assignee) =>
      getAssigneeId(assignee),
    );
    const syncedAssigneeIds = checklistSyncedTaskAssigneeIdsRef.current;
    const assigneeIdsToRemove = Array.from(
      new Set(
        Array.from(syncedAssigneeIds).filter(
          (assigneeId) => !checklistAssigneeIds.has(assigneeId),
        ),
      ),
    );
    const nextSelectedUsers = dedupeAssigneesById([
      ...currentTaskAssignees,
      ...assigneesToAdd,
    ]).filter(
      (assignee) => !assigneeIdsToRemove.includes(getAssigneeId(assignee)),
    );

    if (assigneeIdsToAdd.length || assigneeIdsToRemove.length) {
      selectedUsersRef.current = nextSelectedUsers;
      setSelectedUsers(nextSelectedUsers);
      setSelectedLocalUsers(nextSelectedUsers);
    }

    if (props.taskid) {
      if (assigneeIdsToAdd.length || assigneeIdsToRemove.length) {
        dispatch(
          UpdateTaskAssigee({
            taskid: props.taskid,
            taskassignee: Array.from(
              new Set(
                nextSelectedUsers
                  .filter((user) => user.type !== "team-user")
                  .map((user) => getAssigneeId(user)),
              ),
            ).map((assigneeid) => ({ assigneeid })),
          }),
        );
      }

      if (assigneeIdsToRemove.length) {
        dispatch(
          RemoveTaskAssigee({
            taskid: props.taskid,
            taskassignee: assigneeIdsToRemove.map((assigneeid) => ({
              assigneeid,
            })),
          }),
        );
      }
    }

    checklistAssigneeIds.forEach((assigneeId) =>
      syncedAssigneeIds.add(assigneeId),
    );
    assigneeIdsToAdd.forEach((assigneeId) => syncedAssigneeIds.add(assigneeId));
    assigneeIdsToRemove.forEach((assigneeId) =>
      syncedAssigneeIds.delete(assigneeId),
    );
  }, [checklist]);
  // auto update assigness in main task end
  //////////////////////////////////////

  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty(),
  );

  const changeApplied = (e) => {
    setEditorState(e);
    setChangeComp("changed");
  };

  const handleCommentPastedText = (text, html, currentEditorState) => {
    if (!html) return "not-handled";

    const pastedBlocks = htmlToDraft(normalizeTaskDescriptionLists(html));
    const pastedContent = ContentState.createFromBlockArray(
      pastedBlocks.contentBlocks,
      pastedBlocks.entityMap,
    );
    const contentWithPaste = Modifier.replaceWithFragment(
      currentEditorState.getCurrentContent(),
      currentEditorState.getSelection(),
      pastedContent.getBlockMap(),
    );

    setEditorState(
      EditorState.push(currentEditorState, contentWithPaste, "insert-fragment"),
    );
    setChangeComp("changed");
    return "handled";
  };

  const handleTaskDelete = async () => {
    const resp = await simpleRequest(`/api/User/DeleteTask`, "post", {
      taskid: props.taskid,
      undo: false,
      userid: userId,
    });
    if (resp?.status === true) {
      setShowDeleteModal(false);
      setShowClientDrop(false);
      setShowProjectDrop(false);
      setTimeout(() => {
        setDisabled(false);
        props.setShowModal(false, true);
      }, 1000);
    }
  };

  const handleDraftComment = async () => {
    const newState = RichUtils.toggleInlineStyle(editorState, "BOLD");
    const textMessage = convertToRaw(newState.getCurrentContent());
    const draft = props.maxComments.find(
      (item) => item.isdraft && !item.isdeleted,
    );
    if (textMessage?.blocks[0]?.text?.length) {
      const data = {
        userid: userId,
        relatedtoid: props.taskid,
        message: JSON.stringify(textMessage),
        type: "task",
        isdraft: 1,
        attachments: '""',
        taggedUser: [],
      };
      if (draft)
        await simpleRequest(`/api/User/Delete/UpdateDraftComments`, "post", {
          commentid: draft.commentid,
          type: "Delete",
        });
      await simpleRequest("/api/User/AddComments", "post", { ...data });
    } else if (draft)
      await simpleRequest(`/api/User/Delete/UpdateDraftComments`, "post", {
        commentid: draft.commentid,
        type: "Delete",
      });
  };

  useEffect(() => {
    if (addCommentsRes.status === true) {
      dispatch({
        type: ADD_COMM,
        data: {},
      });
    }
  }, [addCommentsRes]);

  useEffect(() => {
    if (CheckIfTimeSessionStartOrNotResponse?.status === true) {
      if (!props?.taskid) {
        return handleGeneralNotification({
          notificationType: "CUSTOM",
          text: `Please add a task first`,
        });
      }
      dispatch(
        CreateNewTimeSession(
          project?.projectid,
          props.taskid,
          moment().format("DD/MM/YYYY"),
          moment().format("HH:mm:ss"),
          "Work",
          "",
          0,
          window.localStorage.getItem("userid"),
        ),
      );
      dispatch(setCheckTimeSessionToFalse());
    }
    if (CheckIfTimeSessionStartOrNotResponse?.status === false) {
      if (
        CheckIfTimeSessionStartOrNotResponse?.message ===
        "Cannot add another Time"
      ) {
        handleGeneralNotification(
          {
            notificationType: "CUSTOM",
            text: `Timer is already running in ${
              CheckIfTimeSessionStartOrNotResponse?.data?.taskname ||
              GetActiveTimeSessionOnPlanboardResponse?.data?.taskName
            }`,
          },
          false,
        );
        dispatch(setCheckTimeSessionToFalse());
      }
    }
  }, [CheckIfTimeSessionStartOrNotResponse]);

  useEffect(() => {
    if (CreateNewTimeSessionResponse?.status === true) {
      setIsTimerRunning(true);
      window.localStorage.setItem("timerRunning", true);
      window.localStorage.setItem("timerTask", title);
      window.localStorage.setItem(
        "trackingTaskId",
        CreateNewTimeSessionResponse?.data?.projectTaskTrackingTimeid,
      );
      setSession1("00");
      setSession2("00");
      setSession3("00");
      setTaskTrackingId(
        CreateNewTimeSessionResponse?.data?.projectTaskTrackingTimeid,
      );
      dispatch(
        GetActiveTimeSessionOnPlanboard(
          window.localStorage.getItem("userid"),
          moment(new Date()).format("DD/MM/YYYY"),
          `${new Date().getHours().toString().padStart(2, "0")}:${new Date()
            .getMinutes()
            .toString()
            .padStart(2, "0")}:${new Date()
            .getSeconds()
            .toString()
            .padStart(2, "0")}`,
        ),
      );

      // handleGeneralNotification({
      //   notificationType: "CUSTOM",
      //   text: `Your Timer Activity Start`,
      // });
    }
  }, [CreateNewTimeSessionResponse]);

  function timeConvert(n) {
    var num = n;
    var hours = num / 60;
    var rhours = Math.floor(hours).toString().padStart(2, "0");
    var minutes = (hours - rhours) * 60;
    var rminutes = Math.round(minutes).toString().padStart(2, "0");
    var seconds = (minutes - rminutes) * 60;
    var rseconds = Math.round(seconds).toString().padStart(2, "0");
    setSession1(rhours);
    setSession2(rminutes);
    setSession3(Math.abs(rseconds));
    return `${rhours}:${rminutes}:${rseconds}`;
  }
  function formatDate(dateString) {
    if (!dateString) return ""; // Handle the case when dateString is undefined
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}.${month}.${year}`; // Format the date as dd.mm.yyyy
  }

  useEffect(() => {
    let counter = setInterval(() => {
      if (session2 >= 59) {
        if (session3 >= 59) {
          setSession1((hour) => (+hour + 1).toString().padStart(2, "0"));
          setSession2("00");
          setSession3("00");
          return;
        }
      }
      if (session3 >= 59) {
        setSession2((minute) => (+minute + 1).toString().padStart(2, "0"));
        setSession3("00");
        return;
      }
      setSession3((second) => (+second + 1).toString().padStart(2, "0"));
    }, 1000);
    return () => clearInterval(counter);
  }, [session3]);

  useEffect(() => {
    if (GetTimeSessionResponse?.status === true) {
      let date =
        GetTimeSessionResponse?.data?.currentTimeSession?.trackerStartDate.split(
          "T",
        )[0];
      date = `${date}T${GetTimeSessionResponse?.data?.currentTimeSession?.trackerStartTime}`;
      let diff = new Date().getTime() - new Date(date).getTime();
      timeConvert(diff / 60000);
      let n = new Date(0, 0);
      n.setSeconds(+GetTimeSessionResponse?.data?.totalHoursTracked * 60 * 60);
      let total = n.toTimeString().slice(0, 8);
      setIsTimerRunning(true);
      window.localStorage.setItem("timerRunning", true);
      window.localStorage.setItem("timerTask", title);
      window.localStorage.setItem(
        "trackingTaskId",
        GetTimeSessionResponse?.data?.currentTimeSession
          ?.projectTaskTrackingTimeid,
      );
      setTaskTrackingId(
        GetTimeSessionResponse?.data?.currentTimeSession
          ?.projectTaskTrackingTimeid,
      );
      setTotal1(
        GetTimeSessionResponse?.data?.totalHoursTracked
          .toString()
          .split(".")[0]
          ?.padStart(2, "0"),
      );
      setTotal2(
        GetTimeSessionResponse?.data?.totalHoursTracked
          .toString()
          .split(".")[1]
          ?.padStart(2, "0"),
      );
    } else {
      setIsTimerRunning(false);
      setSession1("00");
      setSession2("00");
      setSession3("00");
      setTotal1(
        GetTimeSessionResponse?.data?.totalHoursTracked
          .toString()
          .split(".")[0]
          ?.padStart(2, "0"),
      );
      setTotal2(
        GetTimeSessionResponse?.data?.totalHoursTracked
          .toString()
          .split(".")[1]
          ?.padStart(2, "0"),
      );
      if (StopTimerFromHeaderResponse?.length > 0) return;
      setTaskTrackingId("");
    }
  }, [GetTimeSessionResponse]);

  useEffect(() => {
    if (UpdateTimeSessionResponse?.status === true) {
      setIsTimerRunning(false);
      window.localStorage.setItem("timerRunning", false);
      window.localStorage.removeItem("timerTask");
      setSession1("00");
      setSession2("00");
      setSession3("00");
      setTaskTrackingId("");
      setTotal1(
        UpdateTimeSessionResponse?.data?.totalHoursTracked
          .toString()
          .split(".")[0]
          ?.padStart(2, "0"),
      );
      setTotal2(
        UpdateTimeSessionResponse?.data?.totalHoursTracked
          .toString()
          .split(".")[1]
          ?.padStart(2, "0"),
      );
      if (StopTimerFromHeaderResponse?.length > 0) return;
      window.localStorage.removeItem("trackingTaskId");
    }
  }, [UpdateTimeSessionResponse]);

  const emojiPickerRef = useRef(null);
  useEffect(() => {
    // Function to handle click outside
    const handleClickOutside = (event) => {
      if (
        emojiPickerRef.current &&
        !emojiPickerRef.current.contains(event.target)
      ) {
        // Click occurred outside the emoji picker, so close it
        setShowEmojiPicker(false);
      }
      if (
        dependenciesRef.current &&
        !dependenciesRef.current.contains(event.target)
      ) {
        setShowDependencyDrop(false);
      }
      if (textareaRef.current && !textareaRef.current.contains(event.target)) {
        //setEditDescription(false); // Exit edit mode
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (StopTimerFromHeaderResponse?.length > 0) {
      let tracking = window.localStorage.getItem("trackingTaskId");
      dispatch(
        UpdateTimeSession(
          tracking,
          moment(new Date()).format("DD/MM/YYYY"),
          `${new Date().getHours().toString().padStart(2, "0")}:${new Date()
            .getMinutes()
            .toString()
            .padStart(2, "0")}:${new Date()
            .getSeconds()
            .toString()
            .padStart(2, "0")}`,
        ),
      );
      dispatch(deleteTaskIdFromTimer());
    }
  }, [StopTimerFromHeaderResponse]);

  const selectedUser = (e) => {
    let fullName = `${e?.firstname} ${e?.lastname}`;
    // let afterAt = props.val.split("@")[ 0 ];
    let afterAt = props.val.split("")[0];
    let combineValue = afterAt + fullName;
    props.setVal(combineValue);
    setShowDropPeopleComm(false);
    props.setTaggedUser([e.userid]);
  };

  useEffect(() => {
    if (activeStatusResponse?.status === true) {
      setFullDocPeopleList2(activeStatusResponse?.data);
      setActiveuser(activeStatusResponse?.data);
      setAbbrevation(activeStatusResponse?.data[0]?.firstname);
      setAbbrevationlast(activeStatusResponse?.data[0]?.lastname);
    }
  }, [activeStatusResponse]);
  const toggleEquipmentFun = () => {
    setToggleEquipment(false);
  };
  useEffect(() => {
    if (getSectionsListRes?.status === true) {
      setSectionList(getSectionsListRes?.data);
      if (props.modalFunction === "add") {
        setSectionName(getSectionsListRes?.data[0]?.sectionName);
        setSectionId(getSectionsListRes?.data[0]?.sectionId);
      }
    }
  }, [getSectionsListRes]);

  useEffect(() => {
    if (projectListData?.status == true) {
      setProjectList(projectListData?.data);
      setFullProjectList(projectListData?.data);
      setChoose(projectListData?.data[0]?.contactdetails[0]?.firstname);
      setChooselast(projectListData?.data[0]?.contactdetails[0]?.lastname);

      if (props.defaultContactId) {
        const mapped = projectListData?.data.map((x) => {
          return x.contactdetails[0];
        });
        const findOne = mapped.findIndex(
          (x) => x?.contactid == props?.defaultContactId,
        );
        if (findOne >= 0) {
          let contactid = mapped?.[findOne]?.contactid;
          let contactname = `${mapped?.[findOne]?.firstname} ${mapped?.[findOne]?.lastname}`;
          setClient({ contactid, contactname });
          setCompany(mapped?.[findOne]?.contactclients[0]?.clientname);
        }
      }
    }
  }, [projectListData, props.showModal === true]);

  useEffect(() => {
    if (props?.companyDataSendtoModal !== undefined) {
      // setCompany(props?.companyDataSendtoModal?.historyCompanyName);
      // setCompany(props?.companyDataSendtoModal?.historyCompanyID);

      setClient({
        clientname: props?.companyDataSendtoModal?.historyCompanyName,
        contactid: props?.companyDataSendtoModal?.historyCompanyID,
      });

      console.log("asc4442", props?.companyDataSendtoModal);
    }

    if (localStorage.getItem("companyClientNameFrom3Dot")) {
      setClient({
        clientname: localStorage.getItem("companyClientNameFrom3Dot"),
        contactid: localStorage.getItem("comapanyClientIDFrom3Dot"),
      });

      // Clear localStorage items after setting the client
      setTimeout(() => {
        localStorage.removeItem("companyClientNameFrom3Dot");
        localStorage.removeItem("comapanyClientIDFrom3Dot");
      }, 1000);
    }
  }, [props?.companyDataSendtoModal]);

  useEffect(() => {
    dispatch(fetchUsersByCompany(companyId));
    dispatch(fetchProjectByCompany(companyId));
    dispatch(ProjectDropdown());
  }, []);

  useEffect(() => {
    if (fetchProjectsResponse?.status === true) {
      setMainProjectList(fetchProjectsResponse?.data);
      setFullMainProjectList(fetchProjectsResponse?.data);
    }
  }, [fetchProjectsResponse]);

  useEffect(() => {
    if (updateTaskResponse?.status === true) {
      if (
        props.modalFunction === "update" ||
        props.modalFunction === "Notification"
      ) {
        setShowClientDrop(false);
        setShowProjectDrop(false);
        setTimeout(() => {
          setDisabled(false);
          props.setShowModal(false, true);
          dispatch(ChangeStatus(taskId, updateTaskResponse?.data?.statusid));
        }, 1000);
      }
      // if (location.pathname === "/updateProject") {
      if (location?.pathname.startsWith("/project/")) {
        dispatch(
          FetchTaskByProject(window.localStorage.getItem("projectid"), 1, 10),
        );
      }
      dispatch(emptyTaskState());
    }
  }, [updateTaskResponse]);

  const handleAddChecklist = () => {
    if (checklistTitle != "") {
      dispatch(addCheckList(userId, checklistTitle));
    }
  };

  useEffect(() => {
    if (addTaskResponse?.status === true) {
      setShowClientDrop(false);
      setShowProjectDrop(false);
      const taskidss = addTaskResponse?.data?.taskid;
      window.localStorage.setItem("taskid", taskidss);
      dispatch(emptyTaskState());
      // props.setFetchtaskstatus(true);
      // props.setFetchtaskstatus(addTaskResponse?.data?.taskid);
      props.show
        .filter((x) => x.isdeleted !== 1)
        .map((item) => {
          setTimeout(() => {
            dispatch(
              AddComments(
                userId,
                addTaskResponse?.data.taskid,
                item.message,
                "task",
                item.attachments,
                item.taggedUser,
              ),
            );
          }, 100);
        });
      setTimeout(() => {
        setDisabled(false);
        // props.setShowModal(false, true);
        props.setShowModal(false);
        dispatch({
          type: ADD_TASK,
          data: {},
        });
      }, 1000);
      // window.location.reload();
      // if (location.pathname === "/updateProject") {
      if (location?.pathname.startsWith("/project/")) {
        dispatch(
          FetchTaskByProject(window.localStorage.getItem("projectid"), 1, 10),
        );
      }

      if (selectedLocalUsers?.length) {
        const allAssignees = checklist.flatMap((item) =>
          item.checklistitem.flatMap((x) => x.checklistitemassignees || []),
        );
        // dispatch(
        //   UpdateTaskAssigee({
        //     taskid: addTaskResponse?.data?.taskid,
        //     taskassignee: Array.from(
        //       new Set(allAssignees?.map((user) => user.assigneeid)),
        //     ).map((id) => ({
        //       assigneeid: id,
        //     })),
        //   }),
        // );
      }
      setTimeout(() => {
        setSelectedLocalUsers([]);
      }, 700);
    }
  }, [addTaskResponse]);

  useEffect(() => {
    if (addChecklistResponse?.status === true) {
      setChecklist([
        ...checklist,
        {
          checklistname: addChecklistResponse?.data?.checklisttitle,
          checklistid: addChecklistResponse?.data?.checklistid,
        },
      ]);
      setChecklistTitle("");
      setShowAddItem(false);
    }
  }, [addChecklistResponse]);

  useEffect(() => {
    if (checklist.length) {
      let check = checklist.filter((item) => item.ischecklist === 1);
      if (check.length) {
        let percentage = (check.length / checklist.length) * 100;
        setPercent(percentage);
      } else {
        // handle the case when there are no items with ischecklist equal to 1
        setPercent(0);
      }
    } else {
      // handle the case when the checklist is empty
      setPercent(0);
    }
  }, [checklist]);

  React.useEffect(() => {
    if (deleteChecklistResponse?.status === true) {
      let data = [...checklist];
      data = data.filter(
        (item) => item.checklistid !== deleteChecklistResponse?.data,
      );
      setChecklist(data);
      setTotalCheck(data.length);
    }
  }, [deleteChecklistResponse]);

  useEffect(() => {
    if (fetchTasksResponse?.status === true) {
      let taskDetails = fetchTasksResponse.data[0]?.taskstatus;
      setAllTasks(taskDetails);
    }
  }, [fetchTasksResponse]);

  const [dateError, setDateError] = useState(false);
  const [dateError2, setDateError2] = useState(false);
  useEffect(() => {
    if (props.modelTypeId === process.env.REACT_APP_TASK_STATUS_PROGRESS) {
      setStatusName("In Progress");
      setStatusId(props.modelTypeId);
    }
    if (props.modelTypeId === process.env.REACT_APP_TASK_STATUS_TODO) {
      setStatusName("To Do");
      setStatusId(props.modelTypeId);
    }
  }, [props.modelTypeId]);

  useEffect(() => {
    if (
      !Boolean(props.modelTypeId) &&
      Boolean(props.statusList) &&
      Array.isArray(props.statusList) &&
      Array.from(props.statusList).length > 0
    ) {
      setStatusId(props.statusList[0].statusId);
      setStatusName(props.statusList[0].statusName);
    }
  }, [props.statusList, props.modelTypeId]);

  const [showMoreComm, setShowMoreComm] = useState(false);
  const visibleCommentCount =
    props.maxComments?.filter((item) => !item?.isdraft).length || 0;
  const displayQuantity = showMoreComm ? visibleCommentCount : 5;

  useEffect(() => {
    if (props.modalFunction === "add") {
      setShowClientDrop(false);
      setShowProjectDrop(false);
      props.setTaskid("");
      // setAssignee([]);
      setSelectedUsers([]);
      setChecklist([]);
      setSelectedEquipments([]);
      setDependencyList([]);
      setDueDate(new Date());
      setStartDate(new Date());
      setProject(null);
      setDisableTracking(true);
      setPriorityId(process.env.REACT_APP_TASK_PRIORITY_NORMAL);
      setPriorityName("Normal");
      setDescription("");
      setEditorState2(() => EditorState.createEmpty());
      setWorkAddress("");
      setTitle("");
      setClientSearch("");
      setHours("");
      setMinutes("");
      setClient(null);
      setCompany(null);
      setNotiTime(tt("Don't ") ? tt("Don't ") : "notify");
      setNMinutes(tt("notify") ? tt("notify") : "Don’t");
      props.setComments([]);
      props.setMaxComments([]);
      props.setShow([]);
      props.val && props.setVal("");
      setPercent("");
      setCheck("");
      setTotalCheck("");
      setStatusId(props.modelTypeId);
      setIsTimerRunning(false);
      setSession1("00");
      setSession2("00");
      setSession3("00");
      setTotal1("00");
      setTotal2("00");
      setTaskTrackingId("");
      // if (location.pathname === "/updateProject") {
      if (location?.pathname.startsWith("/project/")) {
        setProject({
          projectid: window.localStorage.getItem("projectid"),
          projectname: window.localStorage.getItem("projectname"),
          projectcode: window.localStorage.getItem("projectcode"),
        });
        setClient({
          contactid: window.localStorage.getItem("clientid"),
          contactname: window.localStorage.getItem("clientname"),
        });
      } else if (
        location.pathname ===
        `/contactlist/edit-contact/${props.defaultContactId}`
      ) {
      } else {
        setProject(null);
        // setClient(null);
      }
      if (companyId === "28830f30-b321-4662-a576-f23451677733") {
        // setStatusId(process.env.REACT_APP_TASK_STATUS_TODO);
        setStatusName("To Do");
      }
      if (companyId === "28830f30-b321-4662-a576-f23451677744") {
        // setStatusId(process.env.REACT_APP_PROJECT_INFO_REQUEST);
        setStatusName("Initiated");
      }
      if (companyId === "28830f30-b321-4662-a576-f23451677755") {
        // setStatusId("08dab011-a6cf-4069-887e-83e5f3473109");
        setStatusName("Initiated");
      }
      if (props.statusName) {
        setStatusName(props.statusName);
      }

      if (props.modelTypeId)
        dispatch(
          GlobalRequest({
            url: `${API_URL}/api/Stage/GetSectionDropdownByStatusId/${props.modelTypeId}`,
            method: "get",
            state: "getSectionsListRes",
            data: {},
          }),
        );
    }
    if (props.modalFunction === "update") {
      setShowClientDrop(false);
      setShowProjectDrop(false);

      if (props.taskid) {
        dispatch(emptyTaskState());
        dispatch(fetchTask(props.taskid));
        fetchComments(props.taskid);
      }

      if (props.modelTypeId)
        dispatch(
          GlobalRequest({
            url: `${API_URL}/api/Stage/GetSectionDropdownByStatusId/${props.modelTypeId}`,
            method: "get",
            state: "getSectionsListRes",
            data: {},
          }),
        );
    } else if (props.modalFunctionNoty === "Notification") {
      setShowClientDrop(false);
      setShowProjectDrop(false);
      if (props.taskid) {
        dispatch(emptyTaskState());
        dispatch(fetchTask(props.taskid));
      }
    }
  }, [
    props.taskid,
    props.modalFunction,
    props.modalFunctionNoty,
    props.showModal,
    taskModalCommentDeleteRes,
    addDocumentToTaskRes,
    // updateTaskAssigneeApiRes,
    // removeTaskAssigneeRes,
  ]);

  const setDraftComment = (data) => {
    const draft = data.find((item) => item.isdraft && !item.isdeleted);
    const html = draft && convertFromRaw(JSON.parse(draft.message));
    if (html && draft.userid === userId)
      setEditorState(() => EditorState.createWithContent(html));
    else setEditorState(() => EditorState.createEmpty());
  };

  const fetchComments = async (taskId) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchComments`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        relatedtoid: taskId,
        type: "task",
      },
    }).then((response) => {
      setDraftComment(response.data.data);
      props.setMaxComments(response.data.data);
    });
  };

  useEffect(() => {
    if (fetchTaskResponse?.status !== true) {
      taskResponseWasClearedRef.current = true;
      return;
    }

    if (
      fetchTaskResponse?.status === true &&
      taskResponseWasClearedRef.current
    ) {
      setIsTaskLoading(false);
      setShowClientDrop(false);
      setShowProjectDrop(false);
      setSelectedEquipments([]);
      if (fetchTaskResponse?.data[0].assignee?.length === 0)
        setDisableTracking(true);
      if (fetchTaskResponse?.data[0].assignee?.length > 0) {
        const mainassignee = fetchTaskResponse?.data[0].assignee?.find(
          (assignee) => {
            return (
              assignee?.assigneeid === window.localStorage.getItem("userid")
            );
          },
        );
        if (mainassignee) {
          setDisableTracking(false);
        } else {
          setDisableTracking(true);
        }
      }
      // setAssignee(fetchTaskResponse?.data[0].assignee);

      let allAssignee = [];
      let userAssignee = fetchTaskResponse?.data[0].assignee ?? [];
      userAssignee = userAssignee.forEach((i) => {
        i.userid = i.assigneeid;
        i.type = "user";
        allAssignee.push(i);
      });
      let teamAssignee = fetchTaskResponse?.data[0].assignedTeams ?? [];
      teamAssignee.forEach((item) => {
        allAssignee.push({
          type: "team",
          teamid: item.teamid,
          userid: item.teamid,
          teammember: item.members,
        });
        item.members.forEach((element) => {
          // remove if same assignee as user
          const individualUserIndex = allAssignee.findIndex(
            (x) => x.userid == element.assigneeid && x.type === "user",
          );
          if (individualUserIndex > -1) {
            allAssignee.splice(individualUserIndex, 1);
          }
          // not add if same assignee as team-user
          const teamUserIndex = allAssignee.findIndex(
            (x) => x.userid == element.assigneeid && x.type === "team-user",
          );
          if (teamUserIndex === -1) {
            element.type = "team-user";
            element.teamid = item.teamid;
            element.userid = element.assigneeid;
            element.assigneeid = element.assigneeid;
            allAssignee.push(element);
          }
        });
      });

      setSelectedUsers(allAssignee);

      setChecklist(fetchTaskResponse?.data[0].checklist);
      setDependencyList(fetchTaskResponse?.data[0].dependencies);
      setPriorityId(fetchTaskResponse?.data[0].priorityid);
      setStatusId(fetchTaskResponse?.data[0].statusid);
      // setDescription(
      //   localStorage.getItem("formName")
      //     ? localStorage.getItem("formName")
      //     : fetchTaskResponse?.data[0].taskdescription
      // );

      // setDescription(fetchTaskResponse?.data[0].taskdescription);
      const blocksFromHtml = htmlToDraft(
        normalizeTaskDescriptionLists(
          fetchTaskResponse?.data[0].taskdescription,
        ),
      );
      const contentState = ContentState.createFromBlockArray(
        blocksFromHtml.contentBlocks,
      );
      const descEditorState = EditorState.createWithContent(contentState);

      setEditorState2(descEditorState);
      // setEditorState2(fetchTaskResponse?.data[0].taskdescription);
      setTypeOfTask(fetchTaskResponse?.data[0].type);
      setWorkAddress(fetchTaskResponse?.data[0]?.workaddress ?? "");
      setTitle(fetchTaskResponse?.data[0].taskname);
      setEstimatedTime(fetchTaskResponse?.data[0].estimatedTime);
      setSelectedEquipments(fetchTaskResponse?.data[0].equipmentdetails || []);

      if (
        fetchTaskResponse &&
        fetchTaskResponse?.data[0] &&
        fetchTaskResponse?.data[0]?.voucher
      ) {
        setVoucherCreated(fetchTaskResponse?.data[0]?.voucher[0]?.isCreated);
        setVoucher(fetchTaskResponse?.data[0]?.voucher[0]);

        if (taskId) {
          PerformaCreatedNotification(fetchTaskResponse?.data[0].voucher);
        }
      }

      setInvoiceCreated(fetchTaskResponse?.data[0]?.requestInvoice);
      setInvoiceCode(fetchTaskResponse?.data[0]?.invoicecode);
      setPaymentDeadline(fetchTaskResponse?.data[0]?.paymentDeadline);
      setPaymentOptions(fetchTaskResponse?.data[0]?.paymentOptions);

      let time2 = `${fetchTaskResponse?.data[0].startingDate}.000Z`;
      setStartDate(new Date(time2));

      if (fetchTaskResponse?.data[0].endDate) {
        let time = `${fetchTaskResponse?.data[0].endDate}.000Z`;
        setDueDate(new Date(time));
        setHours(
          fetchTaskResponse?.data[0].endDate.split("T")[1].split(":")[0] !==
            "00"
            ? fetchTaskResponse?.data[0].endDate.split("T")[1].split(":")[0]
            : "",
        );
        // setMinutes(
        //   fetchTaskResponse?.data[0].endDate.split("T")[1].split(":")[1] !==
        //     "00"
        //     ? fetchTaskResponse?.data[0].endDate.split("T")[1].split(":")[1]
        //     : ""
        // );
        setMinutes(
          fetchTaskResponse?.data[0].endDate.split("T")[1].split(":")[1],
        );
      } else {
        setDueDate(new Date());
      }
      setClient(fetchTaskResponse?.data[0].contact[0]);
      setCompany(
        fetchTaskResponse?.data[0].contact[0]?.clientdetails[0]?.clientname,
      );
      const project1 = {
        projectid: fetchTaskResponse?.data[0]?.project[0]?.projectid,
        projectname: fetchTaskResponse?.data[0]?.project[0]?.projectname,
        projectcode: fetchTaskResponse?.data[0]?.project[0]?.projectcode,
        clientname: fetchTaskResponse?.data[0]?.project[0]?.clientname,
      };
      // if (Boolean(project1?.projectname) === false) {
      //   setDisableTracking(true);
      // }
      dispatch(
        GetTimeSession(
          fetchTaskResponse?.data[0]?.project[0]?.projectid,
          props.taskid,
          window.localStorage.getItem("userid"),
          moment(new Date()).format("DD/MM/YYYY"),
          `${new Date().getHours().toString().padStart(2, "0")}:${new Date()
            .getMinutes()
            .toString()
            .padStart(2, "0")}:${new Date()
            .getSeconds()
            .toString()
            .padStart(2, "0")}`,
        ),
      );
      setProject(project1);
      setNMinutes(fetchTaskResponse?.data[0].notificationunit);
      setNotiTime(fetchTaskResponse?.data[0].notificationvalue);
      const total = [...fetchTaskResponse?.data[0].checklist];
      setTotalCheck(total.length);
      setStatusName(fetchTaskResponse?.data[0].statusName);
      const statusid = fetchTaskResponse?.data[0].statusid;
      const priorityid = fetchTaskResponse?.data[0].priorityid;
      if (priorityid === process.env.REACT_APP_TASK_PRIORITY_EXTREME) {
        setPriorityName("Extreme");
      }
      if (priorityid === process.env.REACT_APP_TASK_PRIORITY_HIGH) {
        setPriorityName("High");
      }
      if (priorityid === process.env.REACT_APP_TASK_PRIORITY_LOW) {
        setPriorityName("Low");
      }
      if (priorityid === process.env.REACT_APP_TASK_PRIORITY_NORMAL) {
        setPriorityName("Normal");
      }
      if (statusid === process.env.REACT_APP_TASK_STATUS_TODO) {
        setStatusName("To Do");
      }
      if (statusid === process.env.REACT_APP_TASK_STATUS_PROGRESS) {
        setStatusName("Progress");
      }
      if (statusid === process.env.REACT_APP_TASK_STATUS_COMPLETE) {
        setStatusName("Complete");
      }
      if (statusid === process.env.REACT_APP_PROJECT_SALES_PIPELINE) {
        setStatusName("Cancelled");
      }
      if (statusid === process.env.REACT_APP_PROJECT_INFO_REQUEST) {
        setStatusName("Initiated");
      }
      if (statusid === process.env.REACT_APP_PROJECT_QUOTE_REQUEST) {
        setStatusName("To Do");
      }
      if (statusid === process.env.REACT_APP_PROJECT_QUOTED) {
        setStatusName("Progress");
      }
      if (statusid === "08dab011-a6cf-4069-887e-83e5f3473108") {
        setStatusName("Complete");
      }
      // if (statusid === "08dab011-a6cf-4069-887e-83e5f3473109") {
      //     setStatusName("Initiated");
      // }
      if (statusid === process.env.REACT_APP_TASK_STATUS_TODO) {
        setStatusName("To Do");
      }
      if (statusid === process.env.REACT_APP_TASK_STATUS_PROGRESS) {
        setStatusName("Progress");
      }
      if (statusid === process.env.REACT_APP_TASK_STATUS_COMPLETE) {
        setStatusName("Complete");
      }
      setSectionName(fetchTaskResponse?.data[0]?.sectionName);
      setSectionId(fetchTaskResponse?.data[0].sectionid);
      setAttachmentsFetchData(fetchTaskResponse?.data[0]?.document);
    }
  }, [fetchTaskResponse, UpdateTimeSessionResponse, props.taskid]);

  const removeEquipment = (id) => {
    setSelectedEquipments((prevItems) =>
      prevItems.filter((item) => item.equipmentid !== id),
    );
  };

  // Activity equipment is already persisted with the activity. Include it for
  // display without adding it to the task's separately saved equipment payload.
  const displayedEquipments = useMemo(
    () =>
      Array.from(
        new Map(
          [...selectedEquipments, ...activityEquipments].map((item) => [
            String(item.equipmentid),
            item,
          ]),
        ).values(),
      ),
    [selectedEquipments, activityEquipments],
  );

  const equipmentPayload = selectedEquipments?.map((item) => ({
    equipmentid: item.equipmentid,
  }));

  useEffect(() => {
    dispatch(FetchActiveUsers(companyId));
  }, []);

  const handleCopyURLFunc = () => {
    const url = `${window.location.origin}/planboard/task/${props.taskid}`;

    navigator.clipboard
      .writeText(url)
      .then(() => {
        setIsActiveDuplicate(false);
        console.log("URL copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  useEffect(() => {
    if (props.taskid && props.modalFunction === "update") {
      history.push(`/planboard/task/${props.taskid}`);
    }
  }, [props.taskid]);

  const handleAddTaskFunc = (duplicate = false) => {
    const assigneeMain = buildTaskAssigneePayload();
    let dependencyMain = [];
    dependencyList.map((dependency) => {
      return dependencyMain.push({
        dependenciesid: dependency.dependenciesid,
      });
    });
    let year = dueDate?.toISOString().split("-")[0];
    const date = dueDate?.getDate();
    let month = dueDate?.toISOString().split("-")[1];
    let datetime;
    if (hours.length <= 2 && minutes.length <= 2) {
      if (year == undefined && month == undefined && date == undefined) {
        datetime = null;
      } else {
        datetime = `${year}-${month}-${date}T${hours.padStart(
          2,
          "0",
        )}:${minutes.padStart(2, "0")}:00.000Z`;
      }
    } else {
      if (year == undefined && month == undefined && date == undefined) {
        datetime = null;
      } else {
        datetime = `${year}-${month}-${date}T00:00:00.000Z`;
      }
    }
    if (title && project?.projectid) {
      setDisabled(true);

      const duplicatedChecklist = checklist.map((item) => ({
        ...item,
        // checklistid: duplicate ? `Copy-${item.checklistid}` : item.checklistid,
        checklistid: duplicate ? "" : item.checklistid,
      }));

      const duplicatedChecklist2 = checklist.map((item) => {
        const newItem = { ...item };

        if (duplicate) {
          delete newItem.checklistid;
          delete newItem.taskchecklistid;

          // Delete checklistitemid inside each checklistitem
          newItem.checklistitem = newItem.checklistitem.map((ci) => {
            const newCI = { ...ci };
            delete newCI.checklistitemid;
            return newCI;
          });
        }

        return newItem;
      });

      dispatch(
        addTask(
          userId,
          companyId,
          project?.projectid ? project.projectid : null,
          duplicate ? `Copy-${title}` : title,
          // description,
          draftToHtml(convertToRaw(editorState2.getCurrentContent())),
          client?.contactid || props.contactidss,
          statusId ? statusId : process.env.REACT_APP_TASK_STATUS_TODO,
          priorityId,
          datetime,
          nminutes,
          notiTime,
          typeOfTask,
          dependencyMain,
          estimatedTime,
          // checklist,
          duplicatedChecklist2,
          assigneeMain,
          workAddress,
          equipmentPayload,
          sectionId || "00000000-0000-0000-0000-000000000000",
          startDate,
          datetime,
          // taskDocumentsPayload
        ),
      );
    } else {
      setShowError(true);
      setShowError2(true);
      setCancel(false);
      modalRef.current.dialog.scrollTo(0, 0);
    }
  };

  const handleFunction = () => {
    if (props.modalFunction === "add") {
      handleAddTaskFunc();
    } else if (props.modalFunction === "update") {
      handleDraftComment();
      setShowClientDrop(false);
      setShowProjectDrop(false);
      const assigneeMain = buildTaskAssigneePayload();
      let dependencyMain = [];
      dependencyList.map((dependency) => {
        return dependencyMain.push({
          dependenciesid: dependency.dependenciesid,
        });
      });
      let year = dueDate?.toISOString().split("-")[0];
      const date = dueDate?.getDate();
      let month = dueDate?.toISOString().split("-")[1];
      let datetime;
      if (hours.length <= 2 && minutes.length <= 2) {
        if (year == undefined && month == undefined && date == undefined) {
          datetime = null;
        } else {
          datetime = `${year}-${month}-${date}T${hours.padStart(
            2,
            "0",
          )}:${minutes.padStart(2, "0")}:00.000Z`;
        }
      } else {
        if (year == undefined && month == undefined && date == undefined) {
          datetime = null;
        } else {
          datetime = `${year}-${month}-${date}T00:00:00.000Z`;
        }
      }
      if (title && project?.projectid) {
        setDisabled(true);
        syncExistingTaskAssignees(assigneeMain);
        dispatch(
          updateTask(
            userId,
            props.taskid,
            title,
            // description,
            draftToHtml(convertToRaw(editorState2.getCurrentContent())),
            "",
            statusId,
            priorityId,
            datetime,
            nminutes,
            notiTime,
            client?.contactid,
            project?.projectid ? project.projectid : null,
            dependencyMain,
            checklist,
            assigneeMain,
            estimatedTime,
            workAddress,
            equipmentPayload,
            sectionId || "00000000-0000-0000-0000-000000000000",
            startDate,
            datetime,
          ),
        );
        // setTimeout(async () => {
        //   await updateTaskIndex(
        //     companyId,
        //     props.taskid,
        //     statusId,
        //     1,
        //     1,
        //     true,
        //     false
        //   );
        // }, 1500);
      } else {
        setShowError(true);
        setShowError2(true);
        setCancel(false);
        modalRef.current.dialog.scrollTo(0, 0);
      }
    } else if (props.modalFunction === "Notification") {
      const assigneeMain = buildTaskAssigneePayload();
      let dependencyMain = [];
      dependencyList.map((dependency) => {
        return dependencyMain.push({
          dependenciesid: dependency.dependenciesid,
        });
      });
      let year = dueDate?.toISOString().split("-")[0];
      const date = dueDate?.getDate();
      let month = dueDate?.toISOString().split("-")[1];
      let datetime;
      if (hours.length <= 2 && minutes.length <= 2) {
        datetime = `${year}-${month}-${date}T${hours.padStart(
          2,
          "0",
        )}:${minutes.padStart(2, "0")}:00.000Z`;
      } else {
        datetime = `${year}-${month}-${date}T00:00:00.000Z`;
      }
      if (title && dueDate) {
        syncExistingTaskAssignees(assigneeMain);
        dispatch(
          updateTask(
            userId,
            props.taskid,
            title,
            // description,
            draftToHtml(convertToRaw(editorState2.getCurrentContent())),
            "",
            statusId,
            priorityId,
            datetime,
            nminutes,
            notiTime,
            client?.contactid,
            project?.projectid ? project.projectid : null,
            dependencyMain,
            checklist,
            assigneeMain,
            estimatedTime,
            workAddress,
            equipmentPayload,
            sectionId || "00000000-0000-0000-0000-000000000000",
            startDate,
            datetime,
          ),
        );
      } else {
        setShowError(true);
        setShowError2(true);
        setCancel(false);
        modalRef.current.dialog.scrollTo(0, 0);
      }
    }
    setChangeComp("");
  };

  const updateChecklist = async (checklistid, ischecklist) => {
    await simpleRequest("/api/User/UpdateChecklist", "post", {
      checklistid,
      ischecklist,
    });
  };

  useEffect(() => {
    if (companyId === "28830f30-b321-4662-a576-f23451677733") {
      const data = [
        { id: process.env.REACT_APP_TASK_STATUS_TODO, name: "To Do" },
        { id: process.env.REACT_APP_TASK_STATUS_PROGRESS, name: "Progress" },
        { id: process.env.REACT_APP_TASK_STATUS_COMPLETE, name: "Complete" },
        { id: process.env.REACT_APP_PROJECT_SALES_PIPELINE, name: "Cancelled" },
      ];
      setStatusData(data);
      setStatusId(data[0].id);
      setStatusName(data[0].name);
      setPlayColor("#C6BE00");
    } else if (companyId === "28830f30-b321-4662-a576-f23451677744") {
      const data = [
        // { id: process.env.REACT_APP_PROJECT_INFO_REQUEST, name: "Initiated" },
        { id: process.env.REACT_APP_TASK_STATUS_TODO, name: "To Do" },
        { id: process.env.REACT_APP_TASK_STATUS_PROGRESS, name: "Progress" },
        { id: process.env.REACT_APP_TASK_STATUS_COMPLETE, name: "Complete" },
      ];
      setStatusData(data);
      setStatusId(data[0].id);
      setStatusName(data[0].name);
      setPlayColor("#08A59E");
    } else {
      const data = [
        // { id: "08dab011-a6cf-4069-887e-83e5f3473109", name: "Initiated" },
        { id: process.env.REACT_APP_TASK_STATUS_TODO, name: "To Do" },
        { id: process.env.REACT_APP_TASK_STATUS_PROGRESS, name: "In Progress" },
        { id: process.env.REACT_APP_TASK_STATUS_COMPLETE, name: "Complete" },
      ];
      setStatusData(data);
      // setStatusId(data[ 0 ].id);
      // setStatusName(data[ 0 ].name);
      setPlayColor("#D8BD90");
    }
    const priority = [
      {
        id: process.env.REACT_APP_TASK_PRIORITY_NORMAL,
        name: tt("Medium"),
      }, // Normal
      {
        id: process.env.REACT_APP_TASK_PRIORITY_LOW,
        name: tt("Low "),
      }, // Low
      {
        id: process.env.REACT_APP_TASK_PRIORITY_HIGH,
        name: tt("High"),
      }, // High
      {
        id: process.env.REACT_APP_TASK_PRIORITY_EXTREME,
        name: tt("Extreme"),
      }, // Extreme
    ];
    setPriorityData(priority);
    setPriorityId(priority[0].id);
    setPriorityName(priority[0].name);
  }, [companyId, fetchAddTask]);

  const [abbrevation, setAbbrevation] = useState();
  const [abbrevationlast, setAbbrevationlast] = useState();

  React.useEffect(() => {
    if (fetchUsersByCompanyResponse?.status === true) {
      setFullDocPeopleList(fetchUsersByCompanyResponse?.data);
      setDocPeopleList(fetchUsersByCompanyResponse?.data);
      setAbbrevation(
        fetchUsersByCompanyResponse?.data[0].userdetails[0].firstname,
      );
      setAbbrevationlast(
        fetchUsersByCompanyResponse?.data[0].userdetails[0].lastname,
      );
    }
  }, [fetchUsersByCompanyResponse]);

  React.useEffect(() => {
    if (clientSearch) {
      let list = [...fullProjectList];
      list = list.filter((client) => {
        const firstName =
          client.contactdetails?.[0]?.firstname?.toLowerCase() || "";
        const lastName =
          client.contactdetails?.[0]?.lastname?.toLowerCase() || "";
        const clientName =
          client.contactdetails?.[0]?.contactclients?.[0]?.clientname?.toLowerCase() ||
          "";
        const fullName = `${firstName} ${lastName}`;

        return (
          firstName.startsWith(clientSearch.toLowerCase()) ||
          lastName.startsWith(clientSearch.toLowerCase()) ||
          clientName.includes(clientSearch.toLowerCase()) ||
          fullName.startsWith(clientSearch.toLowerCase())
        );
      });
      setProjectList(list);
    } else {
      setProjectList([...fullProjectList]);
    }
  }, [clientSearch]);

  React.useEffect(() => {
    if (projectSearch) {
      let list = [...fullMainProjectList];
      list = list.filter((project) => {
        const fullName = `${project.projectname} - ${project.clientname}`;
        return (
          project.projectname
            ?.toLowerCase()
            .includes(projectSearch?.toLowerCase()) ||
          project.projectname
            ?.toLowerCase()
            .startsWith(projectSearch?.toLowerCase()) ||
          project.projectcode
            ?.toLowerCase()
            .includes(projectSearch?.toLowerCase()) ||
          project.clientname
            ?.toLowerCase()
            .startsWith(projectSearch?.toLowerCase()) ||
          fullName?.toLowerCase().startsWith(projectSearch?.toLowerCase())
        );
      });
      setMainProjectList(list);
    } else {
      setMainProjectList([...fullMainProjectList]);
    }
  }, [projectSearch]);

  React.useEffect(() => {
    if (searchPeople) {
      let people = [...fullDocPeopleList2];
      people = people.filter((people) => {
        const fullName = `${people.firstname} ${people.lastname}`;
        return (
          people.firstname
            ?.toLowerCase()
            .startsWith(searchPeople.toLowerCase()) ||
          people.lastname
            ?.toLowerCase()
            .startsWith(searchPeople.toLowerCase()) ||
          fullName.toLowerCase().startsWith(searchPeople.toLowerCase())
        );
      });

      setActiveuser(people);
    } else {
      setActiveuser([...fullDocPeopleList2]);
    }
  }, [searchPeople]);

  const [change, setChange] = useState("");
  const [changeComp, setChangeComp] = useState("");
  const [uploadedFileName, setUploadedFileName] = useState("");
  const [attachmentUrl, setAttachmentUrl] = useState("");
  const extension =
    attachmentUrl && attachmentUrl?.[0].split(".").pop().toLowerCase();
  const isImage = ["jpg", "jpeg", "png", "webp", "gif"].includes(extension);

  const handelCancels = () => {
    if (change !== changeComp) {
      setCancel(true);
      props.setPopups(true);
    } else {
      props.setShowModal(false);
    }
    setChangeComp("");
    dispatch(emptyTaskState());
    // history.push(`/planboard`);
    // if (location.pathname === "/updateProject") {
    if (location?.pathname.startsWith("/project/")) {
      history.push(`/updateProject`);
    } else if (location.pathname === `/contactlist/edit-contact/${id}`) {
      history.push(`/contactlist/edit-contact/${id}`);
    } else if (location.pathname === "/contact-list") {
      history.push(`/contact-list`);
    } else if (location.pathname === "/chat") {
      history.push(`/chat`);
    } else if (location.pathname === "/company-list") {
      history.push(`/company-list`);
    } else if (location.pathname === `/add-company/${id}`) {
      history.push(`/add-company/${id}`);
    } else {
      history.push(`/planboard`);
    }
  };

  const [calendarIsOpen, setCalendarIsOpen] = useState(false);
  const [calendarIsOpen2, setCalendarIsOpen2] = useState(false);

  const datePickerFunc = (val) => {
    setDueDate(val);
    setChangeComp(val);
    setCalendarIsOpen(false);
  };
  const datePickerFunc2 = (val) => {
    setStartDate(val);
    setChangeComp(val);
    setCalendarIsOpen2(false);
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (
      taskSearchRef.current &&
      !taskSearchRef.current.contains(event.target)
    ) {
      setShowClientDrop(false);
    }
    if (
      projectSearchRef.current &&
      !projectSearchRef.current.contains(event.target)
    ) {
      setShowProjectDrop(false);
    }
    if (
      assigneeDropdownRef.current &&
      !assigneeDropdownRef.current.contains(event.target)
    ) {
      setShowDropPeople(false);
      setOpenAssigneeModal(false);
      setSearchPeople("");
      closeAssigneeModal();
    }
    if (
      statusDropdownRef.current &&
      !statusDropdownRef.current.contains(event.target)
    ) {
      setShowStatusDrop(false);
    }
    if (
      sectionDropdownRef.current &&
      !sectionDropdownRef.current.contains(event.target)
    ) {
      setShowSectionDrop(false);
    }
    if (
      priorityDropdownRef.current &&
      !priorityDropdownRef.current.contains(event.target)
    ) {
      setShowPriorityDrop(false);
    }
    if (
      duplicateDropdownRef.current &&
      !duplicateDropdownRef.current.contains(event.target)
    ) {
      setIsActiveDuplicate(false);
    }
    if (
      notificationDropdownRef.current &&
      !notificationDropdownRef.current.contains(event.target)
    ) {
      setShowNotiDropDown(false);
    }
  };

  useEffect(() => {
    if (!props.showModal && props.modalFunction === "add") {
      setShowClientDrop(false);
      setShowProjectDrop(false);
      setProject(null);
      if (
        location.pathname ===
        `/contactlist/edit-contact/${props.defaultContactId}`
      ) {
      } else {
        setCompany(null);
        setClient(null);
      }
    }
  }, [props.showModal]);

  const handleHoursChange = (e) => {
    setChangeComp(e.target.value);
    const value = e.target.value;
    if (/^\d+$/.test(value) && +value >= 0 && +value <= 23) {
      setHours(value);
      if (value.length === 2) {
        document.getElementById("minutesInput").focus();
      }
    }
  };

  const handleMinutesChange = (e) => {
    setChangeComp(e.target.value);
    const value = e.target.value;
    if (/^\d+$/.test(value) && +value >= 0 && +value <= 59) {
      setMinutes(value);
      if (value === "") {
        document.getElementById("hoursInput").focus();
      } else if (value.length === 1 && value === "0" && minutes.length === 2) {
        document.getElementById("hoursInput").focus();
      }
    }
  };

  const handleHoursKeyDown = (e) => {
    setChangeComp(e.key);
    if (e.key === "Backspace") {
      setHours((prevHours) => prevHours.slice(0, prevHours.length - 1));
    }
  };

  const handleMinutesKeyDown = (e) => {
    setChangeComp(e.key);
    if (e.key === "Backspace") {
      if (minutes.length === 0) {
        document.getElementById("hoursInput").focus();
      }
      if (minutes.length > 0) {
        setMinutes((prevMinutes) =>
          prevMinutes.slice(0, prevMinutes.length - 1),
        );
      }
    }
  };

  const [completedTask, setCompletedTask] = useState(null);
  const [projectPO, setprojectPO] = useState("");
  const [clientPO, setClientPO] = useState("");

  const getCompletedTaskByProject = async () => {
    let projectId = project?.projectid ? project.projectid : null;
    let clientId = client?.contactid || props.contactidss;
    setprojectPO(project ? project : null);
    setClientPO(client ? client : null);
    let data = {
      projectId: projectId,
      clientId: clientId,
    };
    var result = await GetCompletedTask(data);
    setCompletedTask(result);
  };

  const [selectedTask, setSelectedTask] = useState([]);
  const [addHours, setAddHours] = useState(false);
  const [equipment, setEquipment] = useState(false);

  const handleAddHoursChange = (event) => {
    setAddHours(event.target.checked);
  };

  const handleEquipmentChange = (event) => {
    setEquipment(event.target.checked);
  };

  const handleDeleteTask = (taskId) => {
    setSelectedTask((prevSelectedTask) =>
      prevSelectedTask.filter((task) => task.taskId !== taskId),
    );
  };

  const handleBuildPO = () => {
    const propsTaskId = props?.taskid;
    const newTaskIdList = [
      propsTaskId,
      ...selectedTask.map((task) => task.taskId),
    ];
    let data = {
      action: "task",
      associatedTasks: newTaskIdList,
      addHourTrackedByEmployee: addHours,
      addEquipmentUsed: equipment,
      project: projectPO,
      client: clientPO,
      activityData,
    };
    history.push("/request-po", data);
  };

  const handleEditPO = async (poId) => {
    GetPOById(poId).then((result) => {
      let data = {
        action: "edit",
        project: { projectId: result[0]?.projectId, projectName: "" },
        client: { clientId: result[0]?.clientId, clientName: "" },
        poResult: result,
      };
      history.push("/request-po", data);
    });
  };

  const closeModal = () => {
    setOpenInvoice(false);
  };

  useEffect(() => {
    let completeStatus = statusData.filter(
      (o) => o.name.toLowerCase() === "complete",
    );

    if (
      changeStateForPO &&
      completeStatus &&
      completeStatus[0] &&
      statusId === completeStatus[0].id
    ) {
      setOpenInvoice(false);
      handleFunction();
    }
  }, [changeStateForPO, statusId]);

  const changeTaskStatusToComplete = () => {
    let completeStatus = statusData.filter(
      (o) => o.name.toLowerCase() === "complete",
    );
    if (completeStatus != null) {
      setStatusId(completeStatus[0].id);
      setStatusName(completeStatus[0].name);
      SetchangeStateForPO(true);
    }
  };

  useEffect(() => {
    const currentContent = editorState.getCurrentContent();
    const textMessage = convertToRaw(currentContent);
    props.setVal(currentContent.hasText() ? JSON.stringify(textMessage) : "");

    if (
      textMessage &&
      textMessage.entityMap &&
      Object.keys(textMessage.entityMap).length > 0
    ) {
      let taggedUsrs = Object.values(textMessage.entityMap);
      const ids = taggedUsrs
        .filter(
          (item) =>
            item.type.toLowerCase() === "mention" &&
            item.data.url !== null &&
            item.data.url !== undefined,
        )
        .map((item) => item.data.url);

      props.setTaggedUser([...new Set(ids)]);
    }
  }, [editorState]);

  const isJson = (item) => {
    let value = typeof item !== "string" ? JSON.stringify(item) : item;
    try {
      value = JSON.parse(value);
    } catch (e) {
      return false;
    }

    return typeof value === "object" && value !== null;
  };

  const getFormattedMessage = (message) => {
    let htmlMessage = "";
    let converFrom = convertFromRaw(JSON.parse(message));
    let convertedHtml = normalizeTaskDescriptionLists(
      draftToHtml(convertToRaw(converFrom)),
    );

    if (convertedHtml !== "<p><br></p>") {
      // Linkify URLs for dangerouslySetInnerHTML
      const linkify = new LinkifyIt();
      const links = linkify.match(convertedHtml);
      // if (links) {
      //   links.forEach((link) => {
      //     const linkTag = `<a href="${link.url}" target="_blank" rel="noopener noreferrer" className="blueTxt">${link.url}</a>`;
      //     convertedHtml = convertedHtml.replace(link.url, linkTag);
      //   });
      // }

      if (links) {
        // Prevent multiple replacements and fix existing malformed links
        convertedHtml = convertedHtml.replace(
          /<a [^>]+>(https?:\/\/[^\s<]+)<\/a>/g,
          "$1",
        ); // Remove incorrectly formatted links

        convertedHtml = convertedHtml.replace(
          /(?<!href=")(https?:\/\/[^\s<]+)/g,
          (url) => {
            return `<a href="${url}" target="_blank" rel="noopener noreferrer" class="blueTxt">${url}</a>`;
          },
        );
      }
      htmlMessage = convertedHtml;
    }
    return htmlMessage;
  };

  const deleteAssignee = (userData) => {
    const deletedAssigneeId = getAssigneeId(userData);
    let oldSelected = [...selectedUsers];
    const oldIndex = oldSelected.findIndex((x) => x.userid === userData.userid);
    const existingItem = oldSelected[oldIndex];
    oldSelected.splice(oldIndex, 1);
    if (existingItem.type === "team-user") {
      // existing team
      const sameTeamIndex = oldSelected.findIndex(
        (x) => x.type === "team" && x.userid === existingItem.teamid,
      );
      if (sameTeamIndex > -1) {
        const team = oldSelected[sameTeamIndex];
        team.teammember.forEach((i) => {
          if (i.userid != existingItem.userid) {
            const existingOtherTeamMemberIndex = oldSelected.findIndex(
              (x) => x.userid === i.userid && x.teamid === existingItem.teamid,
            );
            const existInOtherTeam = oldSelected.some(
              (x) =>
                x.type === "team-user" &&
                x.userid === i.userid &&
                x.teamid !== existingItem.teamid,
            );
            if (existInOtherTeam) {
              oldSelected.splice(existingOtherTeamMemberIndex, 1);
            } else {
              if (existingOtherTeamMemberIndex > -1) {
                oldSelected[existingOtherTeamMemberIndex].type = "user";
                oldSelected[existingOtherTeamMemberIndex].teamid = null;
              }
            }
          }
        });
        oldSelected.splice(sameTeamIndex, 1);
      }

      const selectedUsers = oldSelected.filter(
        (x) => x.type === "team-user" && x.userid === existingItem.userid,
      );
      selectedUsers.forEach((item) => {
        const teamUserIndex = oldSelected.findIndex(
          (x) => x.userid === item.userid && x.teamid == item.teamid,
        );
        oldSelected.splice(teamUserIndex, 1);

        const teamIndex = oldSelected.findIndex(
          (x) => x.type === "team" && x.userid === item.teamid,
        );
        if (teamIndex > -1) {
          const team = oldSelected[teamIndex];
          team.teammember.forEach((i) => {
            if (i.userid != item.userid) {
              const existingOtherTeamMemberIndex = oldSelected.findIndex(
                (x) => x.userid === i.userid && x.teamid === item.teamid,
              );
              const existInOtherTeam = oldSelected.some(
                (x) =>
                  x.type === "team-user" &&
                  x.userid === i.userid &&
                  x.teamid !== item.teamid,
              );
              if (existInOtherTeam) {
                oldSelected.splice(existingOtherTeamMemberIndex, 1);
              } else {
                if (existingOtherTeamMemberIndex > -1) {
                  oldSelected[existingOtherTeamMemberIndex].type = "user";
                  oldSelected[existingOtherTeamMemberIndex].teamid = null;
                }
              }
            }
          });
          oldSelected.splice(teamIndex, 1);
        }
      });
    }
    manualTaskAssigneeIdsRef.current.delete(deletedAssigneeId);
    selectedUsersRef.current = oldSelected;
    setSelectedUsers(oldSelected);
  };

  const showChecklistAssigneeRemoveWarning = () => {
    handleGeneralNotification({
      notificationType: "CUSTOM",
      text: "Unable to remove the assignee. They are currently assigned to checklist tasks",
    });
  };

  const removeTaskAssigneeFromRightSide = (assignee) => {
    if (checklistAssigneeIdsRef.current.has(getAssigneeId(assignee))) {
      showChecklistAssigneeRemoveWarning();
      return;
    }

    deleteAssignee(assignee);
    setSearchPeople("");
    dispatch(
      RemoveTaskAssigee({
        taskid: props.taskid,
        taskassignee: [
          {
            assigneeid: getAssigneeId(assignee),
          },
        ],
      }),
    );
  };

  const onUpdateAssignee = (data) => {
    let allAssignee = [];
    data
      .filter((x) => x.type === "user")
      .forEach((item) => {
        allAssignee.push(item);
      });
    data
      .filter((x) => x.type === "team")
      .forEach((item) => {
        allAssignee.push(item);
        item.teammember.forEach((element) => {
          // remove if same assignee as user
          const individualUserIndex = allAssignee.findIndex(
            (x) => x.userid == element.userid && x.type === "user",
          );
          if (individualUserIndex > -1) {
            allAssignee.splice(individualUserIndex, 1);
          }
          // not add if same assignee as team-user
          const teamUserIndex = allAssignee.findIndex(
            (x) =>
              x.userid == element.userid &&
              x.type === "team-user" &&
              x.teamid != item.teamid,
          );
          element.type = "team-user";
          element.teamid = item.userid;
          element.userid = element.userid;
          element.hide = teamUserIndex > -1;
          allAssignee.push(element);
        });
      });
    const checklistAssignees = getChecklistTaskAssignees(checklist);
    const nextAssignees = dedupeAssigneesById([
      ...allAssignee,
      ...checklistAssignees,
    ]);

    selectedUsersRef.current = nextAssignees;
    setSelectedUsers(nextAssignees);
    manualTaskAssigneeIdsRef.current = new Set(
      allAssignee
        .map((assignee) => getAssigneeId(assignee))
        .filter(
          (assigneeId) => !checklistAssigneeIdsRef.current.has(assigneeId),
        ),
    );
  };

  // postal Code start
  const handleAddressSelect = (address) => {
    const { place_id } = address;
    geocodeByPlaceId(place_id)
      .then((res) => {
        console.log("Found the Address", res);

        if (res && res[0] && res[0].address_components) {
          const { long_name: postalCode = "" } =
            res[0].address_components.find((c) =>
              c.types.includes("postal_code"),
            ) || {};
          // setPinCodeForAdress(postalCode);

          if (!address.description.includes(postalCode)) {
            // setPinCodeForAdress(postalCode);
          }

          const { formatted_address, address_components } = res[0];
          setWorkAddress(formatted_address);
        }
      })
      .catch((err) => {
        console.log("Error while fetching address meta ", err);
      })
      .finally((done) => {
        console.log("Address API Call Completed ", done);
      });
  };
  // postal Code end

  useEffect(() => {
    if (!title && inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const handleAddClient = () => {
    dispatch(
      AddContact(
        userId, // userid
        companyId, // companyid
        clientSearch, // firstname
        "", // lastname
        "", // jobtitle
        "", // photo
        "", // contacttype
        "", // dateofbirth
        "", // maritalstatus
        "", // relationship
        "00000000-0000-0000-0000-000000000000", // accountmanager
        "", // notes
        "", // clientname
        [], // phoneNumbers
        [], // emails
        [], // addresses
        [], // tag
      ),
    );
    setTimeout(() => {
      dispatch(fetchProjectByCompany(companyId));
    }, 1000);
  };

  const [deleteCommOpen, setDeleteCommOpen] = useState(false);
  const [commentDeleteID, setCommentDeleteID] = useState("");

  const handleCommDelete = () => {
    dispatch(DeleteComments(commentDeleteID));
    setDeleteCommOpen(false);
  };

  useEffect(() => {
    if (taskModalCommentDeleteRes?.status === true) {
      // setProjectData(fetchProjectDropdown?.data);
      dispatch({
        type: TASK_MODAL_COMMENT_DELETE,
        data: {},
      });
    }
  }, [taskModalCommentDeleteRes]);

  const [editDescription, setEditDescription] = useState(false);
  useEffect(() => {
    if (
      (fetchTaskResponse.status === true &&
        fetchTaskResponse?.data[0].taskdescription === "") ||
      props.modalFunction === "add"
    ) {
      // setEditDescription(true);
    } else {
      setEditDescription(false);
    }
  }, [fetchTaskResponse]);

  const textareaRef = useRef(null);
  useEffect(() => {
    // Dynamically adjust the height if description has preloaded data.
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [description, editDescription]);

  const linkDecorator = (decoratedHref, decoratedText, key) => (
    <a
      href={decoratedHref}
      key={key}
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: "blue", textDecoration: "underline" }}
    >
      {decoratedText}
    </a>
  );

  // function to put space when shift+enter for Editor start
  useEffect(() => {
    const handleShiftEnter = (e) => {
      console.log("asc editor", e);
      // if (e.target.ariaLabel === "notranslate public-DraftEditor-content") {
      if (e.target.ariaLabel === "rdw-editor") {
        console.log("asc editor 22");
        if (e.key === "Enter" && e.shiftKey) {
          e.preventDefault(); // stop default newline
          const contentState = editorState.getCurrentContent();
          const selection = editorState.getSelection();

          const newContentState = Modifier.insertText(
            contentState,
            selection,
            " ",
          );
          const newEditorState = EditorState.push(
            editorState,
            newContentState,
            "insert-characters",
          );
          setEditorState(newEditorState);
        }
      }
    };

    document.addEventListener("keydown", handleShiftEnter);

    return () => {
      document.removeEventListener("keydown", handleShiftEnter);
    };
  }, [editorState]);
  // function to put space when shift+enter for Editor end

  // change section when we change status start
  const getTaskByStatusRes = useSelector(
    (state) => state.user.getTaskByStatusRes,
  );

  const [newSectionID, setNewSectionID] = useState("");

  useEffect(() => {
    if (statusId) {
      dispatch(
        GlobalRequest({
          url: `${API_URL}/api/Stage/gettaskbystatus/${statusId}`,
          method: "get",
          state: "getTaskByStatusRes",
        }),
      );
    }
  }, [statusId]);

  useEffect(() => {
    if (getTaskByStatusRes?.status === true) {
      console.log("asc332", getTaskByStatusRes.data[0]?.sectionName);
      console.log("asc333", getTaskByStatusRes.data[0]?.sectionId);
      setSectionId(getTaskByStatusRes.data[0]?.sectionId);
    }
  }, [getTaskByStatusRes]);
  // change section when we change status end

  const [attachmentsFetchData, setAttachmentsFetchData] = useState([]);

  // Callback function to receive data from child
  const [dataFromChild, setDataFromChild] = useState([]);
  console.log("asc child Data", dataFromChild);

  const handleDataFromChild = (data) => {
    setDataFromChild(data);
  };

  const taskDocumentsPayload = [...dataFromChild, ...attachmentsFetchData]?.map(
    (item) => ({
      documentId: item.documentId || item.documentid,
      taskDocumentId: item.taskDocumentId && item.taskDocumentId,
    }),
  );
  console.log("asc727", taskDocumentsPayload);

  const [typeOfTask, setTypeOfTask] = useState("");
  const [showTypeOfTask, setShowTypeOfTask] = useState(false);

  const [editorState2, setEditorState2] = useState(() =>
    EditorState.createEmpty(),
  );

  const changeApplied2 = (e) => {
    setEditorState2(e);
    setChangeComp("changed");
  };

  const handleDescriptionPastedText = (text, html, currentEditorState) => {
    if (!html) return "not-handled";

    const normalizedHtml = normalizeTaskDescriptionLists(html);
    const pastedBlocks = htmlToDraft(normalizedHtml);
    const pastedContent = ContentState.createFromBlockArray(
      pastedBlocks.contentBlocks,
      pastedBlocks.entityMap,
    );
    const contentWithPaste = Modifier.replaceWithFragment(
      currentEditorState.getCurrentContent(),
      currentEditorState.getSelection(),
      pastedContent.getBlockMap(),
    );
    const nextEditorState = EditorState.push(
      currentEditorState,
      contentWithPaste,
      "insert-fragment",
    );

    setEditorState2(nextEditorState);
    setChangeComp("changed");
    return "handled";
  };

  const editorRef = useRef(null);
  useEffect(() => {
    if (editDescription) {
      editorRef.current?.focusEditor();
    }
  }, [editDescription]);

  // close assigne popop when we click outside
  const closeAssigneeModal = () => {
    setShowDropPeople(false);
    setOpenAssigneeModal(false);
    setSearchPeople("");

    dispatch(
      UpdateTaskAssigee({
        taskid: props.taskid,
        taskassignee: Array.from(
          new Set(selectedUsersRef.current?.map((user) => getAssigneeId(user))),
        ).map((id) => ({
          assigneeid: id,
        })),
      }),
    );
  };

  // BOM products and part
  const [taskProducts, setTaskProducts] = useState([]);
  const [invoiceCode, setInvoiceCode] = useState("");
  const [newInvoiceCode, setNewInvoiceCode] = useState("");
  const [paymentDeadline, setPaymentDeadline] = useState("");
  const [paymentOptions, setPaymentOptions] = useState("");

  const handleProductsChange = (rows) => {
    const filteredRows = rows.filter((row) => row.productPartName?.trim());
    console.log("ascbom", filteredRows);
    setTaskProducts(filteredRows);
  };

  useEffect(() => {
    dispatch(FetchLastInvoiceCode(companyId));
  }, [companyId]);

  useEffect(() => {
    if (fetchLastInvoiceCodeRes?.status === true) {
      setNewInvoiceCode(fetchLastInvoiceCodeRes?.data);
    }
  }, [fetchLastInvoiceCodeRes]);

  const handleAddInvoice = () => {
    const productsTotal2 = taskProducts.reduce(
      (sum, item) => sum + Number(item.total || 0),
      0,
    );

    const productsTotal = taskProducts.reduce((sum, item) => {
      const total = Number(item.total || 0);
      const vatPercent = Number(item.vatpercent || 0);

      const vatAmount = (total * vatPercent) / 100;

      return sum + total + vatAmount;
    }, 0);

    const invoiceTotal =
      Number(fetchTaskResponse?.data[0]?.workerEquipmentTotal || 0) +
      productsTotal;

    console.log("ascr5", invoiceTotal);

    dispatch(
      CreateInvoice({
        projectid: project?.projectid,
        quoteid: "00000000-0000-0000-0000-000000000000",
        companyid: companyId,
        taskid: props.taskid,
        invoicecode: newInvoiceCode,
        paymentdeadline: paymentDeadline,
        duedate: dueDate,
        paymentoptions: paymentOptions,
        invoicestatus: "Not Sent",
        invoicetotal: invoiceTotal,
        milestones: taskProducts.map((item, index) => ({
          productid: item.productPartid,
          qty: String(item.qty),
          vatpercent: item.vatpercent,
          // discount: "string",
          total: String(item.total),
          // suffix: "string",
          indexPosition: index,
        })),
      }),
    ).then((res) => {
      if (res?.status === true) {
        setInvoiceCreated(res?.status);
        handleGeneralNotification({
          notificationType: "CUSTOM",
          text: `Invoice ${newInvoiceCode} generated successfully.`,
        });
      }
    });
  };

  return (
    <>
      {deleteCommOpen && (
        <TaskDelete
          animation={true}
          handleDelete={handleCommDelete}
          show={deleteCommOpen}
          onHide={() => setDeleteCommOpen(false)}
        />
      )}

      {showDeleteModal && (
        <TaskDelete
          animation={true}
          handleDelete={handleTaskDelete}
          show={showDeleteModal}
          onHide={() => setShowDeleteModal(false)}
        />
      )}

      <div className="asc">
        <Modal
          // backdrop={"static"}
          keyboard={false}
          className="contact-task-width"
          show={props.showModal}
          onHide={() => {
            if (change !== changeComp) {
              setCancel(true);
              // props.setPopups(true); // block auto close
            } else {
              props.setShowModal(false);
            }
          }}
          ref={modalRef}
          dialogClassName={`modal-90w ${
            isTaskLoading ? "task-loading-dialog" : ""
          }`}
          contentClassName={isTaskLoading ? "task-loading-content" : ""}
          aria-labelledby="contained-modal-title-vcenter"
          centered
          id="add-task-modal-pop"
          style={{
            background: "#F2F2F2 0% 0% no-repeat padding-box",
            opacity: "0.95",
            marginTop: "0px",
            // zIndex: 10,
          }}
        >
          {isTaskLoading && <Loader />}
          <div
            className="task-modal-main-grid-pop"
            style={{
              display: isTaskLoading ? "none" : undefined,
              pointerEvents:
                roleAccess === process.env.REACT_APP_IS_VIEWER && "none",
            }}
          >
            <div className="task-modal-left-main">
              <div
                style={{
                  width: "900px",
                  padding: 0,
                }}
                className="task-modal-left-top-pop"
              >
                {props.modalFunction !== "add" && !props.isBasicMember && (
                  <div style={{ display: "flex", justifyContent: "end" }}>
                    {/* <Tooltip
                      title={`Created by ${userfirstname} ${
                        userlastname ? userlastname : ""
                      } on ${
                        fetchTaskResponse &&
                        fetchTaskResponse?.data &&
                        fetchTaskResponse?.data?.length > 0
                          ? formatDate(
                              fetchTaskResponse?.data[0]?.createdat?.split(
                                "T"
                              )[0]
                            )
                          : ""
                      }`}
                      color={"gray"}
                      placement="bottomRight"
                    >
                      <InfoCircleOutlined />
                    </Tooltip> */}
                  </div>
                )}
                <div className="frcb" style={{ padding: "15px 2rem 0 2rem" }}>
                  <div className="frc">
                    <img
                      alt=""
                      className="task-icon-pop ms-2"
                      src={Clipboard}
                      style={{ display: "inline-block" }}
                    />
                    <p className="margin-0-pop task-modal-task-text-pop">
                      {tt("Task")}
                    </p>

                    {/* new timer div */}
                    <div
                      className="ms-3 d-flex"
                      style={{
                        backgroundColor: isTimerRunning ? "#95A7C6" : "#F1F1F1",
                        color: isTimerRunning && "#ffffff",
                        opacity: disableTracking ? "50%" : "100%",
                        borderRadius: "8px",
                        width: "260px",
                        border: "1px solid #a5a5a580",
                        justifyContent: "unset",
                      }}
                    >
                      <p
                        className="mb-0 ps-3 w-100"
                        style={{ paddingTop: "12px" }}
                      >
                        Track time
                      </p>
                      <div
                        className="track-time-box mt-1 ms-4"
                        onClick={() => {
                          if (disableTracking) return;
                          if (isTimerRunning) {
                            setChangeComp("changed");
                            return dispatch(
                              UpdateTimeSession(
                                taskTrackingId,
                                moment().format("DD/MM/YYYY"),
                                moment().format("HH:mm:ss"),
                              ),
                            );
                          }
                          if (!props?.taskid) {
                            return handleGeneralNotification({
                              notificationType: "CUSTOM",
                              text: `Please add a task first`,
                            });
                          }
                          setChangeComp(true);
                          dispatch(
                            CheckIfTimeSessionStartOrNot(
                              project?.projectid,
                              props.taskid,
                              window.localStorage.getItem("userid"),
                              moment().format("DD/MM/YYYY"),
                              moment().format("HH:mm:ss"),
                            ),
                          );
                        }}
                        style={{
                          backgroundColor: isTimerRunning
                            ? "#95A7C6"
                            : "#F1F1F1",
                          cursor: disableTracking ? "default" : "pointer",
                          justifyContent: "unset",
                        }}
                      >
                        <div className="d-flex">
                          <p
                            className="margin-0 start-text fw-semibold"
                            style={{
                              color: isTimerRunning && "#ffffff",
                              opacity: disableTracking ? "50%" : "100%",
                            }}
                          >
                            {isTimerRunning ? "Stop" : "Start"}
                          </p>
                        </div>
                        {isTimerRunning ? (
                          <img alt="" src={Stop} />
                        ) : (
                          <img
                            alt=""
                            src={disableTracking ? TriangleLight : stopCircle}
                          />
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Type of Task start */}
                  <div className="d-flex gap-3 align-items-center position-relative d-none">
                    <p className="mb-1 typeOfTask">Type of Task</p>
                    <p
                      className="mb-0 px-2 typeOfStory"
                      style={{ border: "1px solid #95a7c6" }}
                      onClick={() => setShowTypeOfTask(!showTypeOfTask)}
                    >
                      {typeOfTask ? typeOfTask : "Select Type"}
                    </p>
                  </div>

                  {showTypeOfTask && props.modalFunction === "add" && (
                    <div className="typeOfTaskDropDown">
                      <div className="typeOfTaskHeader py-3 px-3">
                        <p className="mb-0">Type of Task</p>
                        <img
                          src={xIcon}
                          alt=""
                          width={20}
                          className="pointer"
                          onClick={() => setShowTypeOfTask(false)}
                        />
                      </div>

                      <div className="typeOfTaskBody py- px-3">
                        <div
                          className="typeOfTaskUnderBody"
                          onClick={() => {
                            setTypeOfTask("Epic");
                            setShowTypeOfTask(false);
                          }}
                        >
                          <p className="mb-0 py-3">Epic</p>
                          <p
                            className="taskTypeColor my-2"
                            style={{
                              background: "blue",
                            }}
                          ></p>
                        </div>

                        <div
                          className="typeOfTaskUnderBody"
                          onClick={() => {
                            setTypeOfTask("Story");
                            setShowTypeOfTask(false);
                          }}
                        >
                          <p className="mb-0 py-3">Story</p>
                          <p
                            className="taskTypeColor my-2"
                            style={{
                              background: "green",
                            }}
                          ></p>
                        </div>

                        <div
                          className="typeOfTaskUnderBody"
                          onClick={() => {
                            setTypeOfTask("Task");
                            setShowTypeOfTask(false);
                          }}
                        >
                          <p className="mb-0 py-3">Task</p>
                          <p
                            className="taskTypeColor my-2"
                            style={{
                              background: "grey",
                            }}
                          ></p>
                        </div>
                      </div>
                    </div>
                  )}
                  {/* Type of Task end */}

                  <div
                    className="task-modal-duplicate-icon-box"
                    ref={duplicateDropdownRef}
                  >
                    <div
                      className="task-modal-duplicate-icon"
                      onClick={() => setIsActiveDuplicate(true)}
                    >
                      <img
                        alt=""
                        src={threeDots}
                        style={{ transform: "rotate(90deg)" }}
                      />
                    </div>
                    {isActiveDuplicate && (
                      <div className="task-modal-duplicate-pop-box">
                        <img
                          alt=""
                          className="pointer"
                          src={threeDots}
                          style={{
                            transform: "rotate(90deg)",
                            marginLeft: "20px",
                          }}
                          onClick={() => setIsActiveDuplicate(false)}
                        />
                        <div className="task-modal-duplicate-list">
                          <div
                            className="frc task-modal-duplicate-list-item"
                            style={{ gap: "18px" }}
                            onClick={handleCopyURLFunc}
                          >
                            <img
                              alt=""
                              src={shareIcon}
                              width={18}
                              height={20}
                            />
                            <p className="mb-0">
                              {/* Share */}
                              {t("Copy Task URL")}
                            </p>
                          </div>
                          <div
                            className="frc task-modal-duplicate-list-item"
                            style={{ gap: "18px" }}
                            onClick={() => handleAddTaskFunc(true)}
                          >
                            <img
                              alt=""
                              src={duplicateIcon}
                              width={18}
                              height={20}
                            />
                            <p className="mb-0">
                              {/* Duplicate */}
                              {t("Duplicate")}
                            </p>
                          </div>
                          <div
                            className="frc task-modal-duplicate-list-item"
                            style={{ gap: "18px" }}
                            onClick={() => setShowDeleteModal(true)}
                          >
                            <img
                              alt=""
                              src={deleteIcon}
                              width={18}
                              height={20}
                            />
                            <p className="mb-0">
                              {/* Delete */}
                              {t("Delete")}
                            </p>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div
                  className="fc"
                  style={{
                    rowGap: "8px",
                    marginTop: "16px",
                    padding: "0 2rem",
                  }}
                >
                  <div
                    className="task-modal-new-main-box"
                    style={{
                      border:
                        document.activeElement === inputRef.current &&
                        "0.8px solid #333333",
                    }}
                  >
                    <div
                      className="task-modal-new-main-box-heading"
                      style={{
                        color:
                          !title || document.activeElement === inputRef.current
                            ? "#333333"
                            : "#a5a5a5",
                        borderRight:
                          document.activeElement === inputRef.current &&
                          "0.8px solid #333333",
                      }}
                    >
                      {/* Task title* */}
                      {t("Task Title")} {"*"}
                    </div>
                    <input
                      ref={inputRef}
                      type="text"
                      value={title}
                      disabled={roleAccess === process.env.REACT_APP_IS_VIEWER}
                      placeholder={"* " + tt("Type a title")}
                      onChange={(e) => {
                        setTitle(e.target.value);
                        setChangeComp(e.target.value);
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleFunction();
                        }
                      }}
                      style={{
                        border: showError ? "1px solid red" : "none",
                        borderRadius: "5px",
                      }}
                      className="task-modal-new-main-box-input"
                    />
                  </div>
                  {fetchAppSideNavOptions &&
                    Array.isArray(fetchAppSideNavOptions) &&
                    fetchAppSideNavOptions.every(
                      (item) => item.packageName !== "Basic",
                    ) && (
                      <div
                        className="task-modal-new-main-box"
                        ref={projectSearchRef}
                      >
                        <div
                          className="task-modal-new-main-box-heading"
                          style={{
                            color: project?.projectname ? "#a5a5a5" : "#333333",
                          }}
                        >
                          {/* Project */}
                          {t("Project")} {"*"}
                        </div>
                        <div
                          className="frcb"
                          style={{
                            width: "76%",
                            border: showError2 ? "1px solid red" : "none",
                            borderRadius: "5px",
                          }}
                        >
                          <p
                            style={{
                              color: project?.projectname
                                ? "#333333"
                                : "#a5a5a5",
                              paddingLeft: "10px",
                              cursor: "pointer",
                              fontSize: "14px",
                              width: "-webkit-fill-available",
                            }}
                            className="mb-0"
                            onClick={() => setShowProjectDrop(true)}
                          >
                            {project?.projectname
                              ? `${project?.projectcode} ┃ ${project?.projectname}`
                              : `* ${t("Choose a Project")}`}
                            {/* : "Choose a Project"} */}
                          </p>
                          {project?.projectname && (
                            <img
                              alt=""
                              src={xCircleMainIcon}
                              style={{ cursor: "pointer" }}
                              onClick={() => setProject(null)}
                            />
                          )}
                        </div>
                        {showProjectDrop && (
                          <div>
                            <div
                              className="client-drop"
                              style={{
                                top: 0,
                                left: "16%",
                                width: "84%",
                                maxHeight: "335px",
                              }}
                            >
                              <p className="mb-2" style={{ opacity: "60%" }}>
                                {/* Choose a Project */}
                                {t("Choose a Project")}
                              </p>
                              <div
                                className="task-modal-new-popup-search"
                                style={{ marginBottom: "10px" }}
                              >
                                <img
                                  alt=""
                                  className="mb-1 search_pop ms-2"
                                  src={searchIcon}
                                />
                                <input
                                  type="text"
                                  autoFocus={true}
                                  value={projectSearch}
                                  style={{
                                    margin: "0 0 0 0.5rem",
                                    fontSie: "14px",
                                    fontWeight: projectSearch ? "400" : "300",
                                    color: projectSearch ? "" : "#D5D5D5",
                                  }}
                                  // placeholder="Search"
                                  placeholder={tt("search")}
                                  className="search-style select-client-div"
                                  onChange={(e) => {
                                    setChangeComp(e.target.value);
                                    setProjectSearch(e.target.value);
                                  }}
                                />
                              </div>
                              <div className="my-custom-scrollbar">
                                {mainProjectList?.map((project, index) => {
                                  return (
                                    <p
                                      className="mb-0 ulterDrop"
                                      key={`${index}-${project.projectid}`}
                                      style={{
                                        textTransform: "capitalize",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => {
                                        setProject({
                                          projectid: project.projectid,
                                          projectname: project.projectname,
                                          projectcode: project.projectcode,
                                          clientname: project.clientname,
                                        });

                                        // setClient({ contactid, contactname });
                                        setClient({
                                          clientname: project?.clientname,
                                          contactid: project?.clientid,
                                        });
                                        setWorkAddress(project.deliveryaddress);
                                        setShowProjectDrop(false);
                                        setChangeComp(project);
                                      }}
                                    >
                                      {project
                                        ? project.clientname
                                          ? `${project.projectcode} ┃ ${
                                              project?.projectname
                                            } - ${
                                              location.pathname !==
                                                "/addProject" &&
                                              // location.pathname !==
                                              //   "/updateProject" &&
                                              !location.pathname.startsWith(
                                                "/project/",
                                              ) &&
                                              project?.clientname
                                            }`
                                          : `${project.projectcode} ┃ ${project.projectname}`
                                        : `${project.projectname}`}
                                    </p>
                                  );
                                })}
                              </div>
                              <div
                                className="gotoproject"
                                onClick={() => {
                                  history.push(`/addProject`, "/project", {
                                    from: "planboard_Screen",
                                  });
                                }}
                              >
                                <p className="mb-0">Create Project</p>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    )}

                  <div className="task-modal-new-main-box" ref={taskSearchRef}>
                    <div
                      className="task-modal-new-main-box-heading"
                      style={{
                        color: client?.contactname ? "#a5a5a5" : "#333333",
                      }}
                    >
                      {/* Client */}
                      {t("Client")}
                    </div>
                    <div className="frcb" style={{ width: "76%" }}>
                      <p
                        style={{
                          color:
                            client?.clientname || client?.contactname
                              ? "#333333"
                              : "#a5a5a5",
                          paddingLeft: "10px",
                          cursor: "pointer",
                          fontSize: "14px",
                          width: "-webkit-fill-available",
                        }}
                        className="mb-0"
                        onClick={() => setShowClientDrop(!showClientDrop)}
                        onChange={(e) => {
                          setChangeComp(e.target.value);
                        }}
                      >
                        {/* {client || // when i select from project dropdown.
                          client?.contactname ||
                          `${fetchAddTask[19]?.translation}`}
                        {company ? (
                          <span style={{ marginLeft: "5px" }}>
                            {" "}
                            | {company}
                          </span>
                        ) : (
                          ""
                        )} */}

                        {client?.clientname ||
                        client?.contactname ||
                        company ? (
                          <>
                            {client?.clientname || client?.contactname}
                            {company && (
                              <span style={{ marginLeft: "5px" }}>
                                {" "}
                                | {company}
                              </span>
                            )}
                          </>
                        ) : (
                          tt("Choose a client")
                        )}
                      </p>

                      {client?.clientname && client?.contactname && (
                        <img
                          alt=""
                          src={xCircleMainIcon}
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setClient(null);
                            setCompany(null);
                          }}
                        />
                      )}
                    </div>
                    {showClientDrop && (
                      <div
                        className="client-drop"
                        style={{
                          top: 0,
                          left: "16%",
                          width: "84%",
                          maxHeight: "335px",
                        }}
                      >
                        <p className="mb-2">
                          {/* Choose a client */}
                          {tt("Choose a client")}
                        </p>
                        <div
                          className="client-search-main2"
                          style={{ marginBottom: "10px" }}
                        >
                          <img
                            alt=""
                            className="mb-1 search_pop ms-2"
                            src={searchIcon}
                          />
                          <input
                            autoFocus={true}
                            type="text"
                            value={clientSearch}
                            style={{
                              margin: "0 0 0 0.5rem",
                              fontSize: "14px",
                              fontWeight: clientSearch ? "400" : "300",
                              color: clientSearch ? "" : "#D5D5D5",
                            }}
                            // placeholder="Search"
                            placeholder={tt("search")}
                            className="search-style select-client-div"
                            onChange={(e) => {
                              setChangeComp(e.target.value);
                              setClientSearch(e.target.value);
                            }}
                          />
                          <img
                            src={PlusIcon}
                            alt=""
                            className={
                              clientSearch ? "d-none" : "pointerEvent d-none"
                            }
                            onClick={() => {
                              handleAddClient();
                            }}
                          />
                        </div>
                        <div className="my-custom-scrollbar">
                          {projectList?.map((project, index) => {
                            return (
                              <p
                                className="mb-0 my-custom-para ulterDrop"
                                key={`index-${project?.contactdetails?.[0]?.contactid}-${index}`}
                                style={{
                                  textTransform: "capitalize",
                                  backgroundColor:
                                    client?.contactname ===
                                    `${project.contactdetails?.[0]?.firstname} ${project.contactdetails?.[0]?.lastname}`
                                      ? "#F4F5F4"
                                      : "transparent",
                                }}
                                onClick={() => {
                                  let contactid =
                                    project?.contactdetails?.[0]?.contactid;
                                  let contactname = `${project?.contactdetails?.[0]?.firstname} ${project?.contactdetails?.[0]?.lastname}`;
                                  setClient({ contactid, contactname });
                                  setCompany(
                                    project?.contactdetails[0]
                                      ?.contactclients[0]?.clientname,
                                  );
                                  setShowClientDrop(false);
                                  setChangeComp(project);
                                }}
                              >
                                {`${project?.contactdetails?.[0]?.firstname} ${project?.contactdetails?.[0]?.lastname}`}
                                {project?.contactdetails?.[0]
                                  ?.contactclients?.[0]?.clientname
                                  ? ` ┃ ${project.contactdetails[0].contactclients[0].clientname}`
                                  : ""}
                              </p>
                            );
                          })}
                        </div>
                        <div
                          className="gotoproject"
                          onClick={() => {
                            history.push("/add-contact", {
                              from: "planboard_Screen",
                            });
                          }}
                        >
                          <p className="mb-0">Create Contact</p>
                        </div>
                      </div>
                    )}
                  </div>
                  {!props?.isBasicMember && (
                    <div
                      className="task-modal-new-main-box"
                      style={{ minHeight: "70px" }}
                    >
                      <div
                        className="task-modal-new-main-box-heading"
                        style={{
                          alignItems: "start",
                          paddingTop: "2px",
                          color: workAddress ? "#a5a5a5" : "#333333",
                        }}
                      >
                        {/* Address */}
                        {t("Address")}
                      </div>
                      <div
                        className="task-modal-new-address-box"
                        id="task-modal-new-address-box"
                      >
                        {/* <textarea
                      name="workAddress"
                      className={"margin-left-main-pop text-description-pop ps-2"}
                      placeholder={"Type a Work Address"}
                      value={workAddress}
                      onChange={(e) => {
                        setWorkAddress(e.target.value);
                        setChangeComp(e.target.value);
                      }}
                    />  */}
                        <GooglePlacesAutocomplete
                          debounce={800}
                          renderInput={(props) => (
                            <textarea
                              style={{
                                border: "none",
                                width: "100%",
                                height: "50px",
                                fontSize: "14px",
                                overflow: "hidden",
                              }}
                              {...props}
                              rows={4}
                              // placeholder="Type a Work Address"
                              placeholder={t("Type a Address")}
                            />
                          )}
                          onSelect={(e) => {
                            // handleAddressSelect(e);
                            setWorkAddress(e.description);
                            setChangeComp(e.description);
                            handleAddressSelect(e);
                          }}
                          // placeholder="Type a Work Address"
                          placeholder={t("Type a Address")}
                          initialValue={workAddress}
                          withSessionToken={true}
                        />
                      </div>
                    </div>
                  )}
                  <div
                    className="task-modal-description-main-box"
                    id="addTaskComntBox2"
                  >
                    <div
                      className="task-modal-description-heading"
                      style={{ color: description ? "#a5a5a5" : "#333333" }}
                    >
                      {tt("Task Description")}
                    </div>
                    <div className="task-modal-new-address-box"></div>

                    {editDescription ? (
                      <>
                        <textarea
                          ref={textareaRef}
                          name="description"
                          className="task-modal-description-textarea d-none"
                          placeholder={tt("Type a description")}
                          value={description}
                          onChange={(e) => {
                            setDescription(e.target.value);
                            setChangeComp(e.target.value);

                            // Adjust the height of the textarea dynamically👇
                            e.target.style.height = "auto";
                            e.target.style.height = `${e.target.scrollHeight}px`;
                          }}
                          onClick={() => {
                            if (
                              // description === localStorage.getItem("formName")
                              description &&
                              localStorage.getItem("formName") &&
                              description === localStorage.getItem("formName")
                            ) {
                              history.push({
                                pathname: "/form-builder",
                                state: { formPopUp: false },
                              });
                              localStorage.setItem("formCondition", false);
                              const formId = localStorage.getItem("formId");
                              dispatch(fetchFormById(formId));
                            }
                          }}
                          disabled={
                            roleAccess === process.env.REACT_APP_IS_VIEWER
                          }
                          style={{
                            cursor:
                              roleAccess === process.env.REACT_APP_IS_VIEWER
                                ? "default"
                                : description ===
                                    localStorage.getItem("formName") &&
                                  "pointer",
                            color: "black",
                            height: "auto",
                            overflow: "hidden",
                          }}
                        />

                        <Editor
                          name="description"
                          ref={editorRef}
                          placeholder={fetchAddTask[20]?.translation}
                          // value={description}
                          editorState={editorState2}
                          onEditorStateChange={changeApplied2}
                          handlePastedText={handleDescriptionPastedText}
                          wrapperClassName="wrapper-class ms-"
                          editorClassName="task-comment-text-pop2 text-black"
                          toolbarClassName="toolbar-bottom-absolute"
                          toolbarHidden={true}
                          mention={{
                            separator: " ",
                            trigger: "@",
                            suggestions: activeuser.map((x) => ({
                              text: `${x.firstname} ${x.lastname}`,
                              value: `${x.firstname} ${x.lastname}`,
                              url: x.userid,
                            })),
                          }}
                        />
                      </>
                    ) : (
                      <div
                        className="p-3"
                        style={{
                          // The description is rendered as parsed HTML. Using
                          // pre-wrap also displays whitespace between HTML
                          // tags, which creates large gaps between blocks.
                          whiteSpace: "normal",
                          wordWrap: "break-word", // Handle long words gracefully
                          color: "black", // Plain text color
                          fontSize: "14px",
                        }}
                        onClick={(e) => {
                          // Check if the clicked element is a link
                          if (e.target.tagName.toLowerCase() !== "a") {
                            console.log("asc44", e.target);
                            console.log("asc445", e.target.innerHTML);
                            console.log("asc446", e.target.innerText);
                            // setEditDescription(true); // Enable edit mode only if not clicking a link
                          }
                          setEditDescription(true);
                          setEditorState2(
                            EditorState.moveFocusToEnd(editorState2),
                          );
                        }}
                        onDoubleClick={() => {
                          setEditDescription(true);
                        }}
                      >
                        {/* <Linkify>{description}</Linkify> */}
                        <Linkify componentDecorator={linkDecorator}>
                          {/* {description} */}
                          {parse(
                            normalizeTaskDescriptionLists(
                              draftToHtml(
                                convertToRaw(editorState2.getCurrentContent()),
                              ),
                            ),
                          )}
                        </Linkify>
                      </div>
                    )}
                  </div>
                </div>
                <div className="d-flex gap-2 pt-2 pe-5">
                  <button
                    className="ms-auto descButton invisible"
                    style={{
                      height: "25px",
                      fontSize: "12px",
                      background: "#ffffff",
                      color: "#5b5b5b",
                      border: "1px solid #5b5b5b",
                      borderRadius: "8px",
                    }}
                    onClick={() => {
                      setEditDescription(true);
                    }}
                  >
                    <img
                      src={editDescription ? whitePen : ""}
                      className={editDescription ? "pe-1" : ""}
                      alt=""
                      width={16}
                    />
                    {/* Edit */}
                    {t("Edit ")}
                  </button>

                  <button
                    className={
                      props.modalFunction === "update" && editDescription
                        ? "descButton"
                        : "d-none"
                    }
                    style={{
                      height: "25px",
                      fontSize: "12px",
                      background: "#00246a",
                    }}
                    onClick={() => {
                      setEditDescription(false);
                      dispatch(
                        UpdateTaskDescription({
                          taskid: props.taskid,
                          taskdescription: draftToHtml(
                            convertToRaw(editorState2.getCurrentContent()),
                          ),
                        }),
                      );
                    }}
                  >
                    ✓ &nbsp;
                    {/* Save */}
                    {t("Save")}
                  </button>
                </div>

                {/* Attachments */}
                <Attachments
                  setChangeComp={setChangeComp}
                  taskId={props.taskid}
                  setTaskId={props.setTaskid}
                  modalFunction={props.modalFunction}
                  attachmentsFetchData={attachmentsFetchData}
                  childData={handleDataFromChild}
                  // translation1={fetchAddTask[2]?.translation}
                  // translation2={fetchAddTask[11]?.translation}
                  // translation3={fetchAddTask[17]?.translation}
                  // translation4={fetchAddTask[41]?.translation}
                />

                {/* AddForm */}
                <AddForm
                  setChangeComp={setChangeComp}
                  taskId={props.taskid}
                  setTaskId={props.setTaskid}
                  modalFunction={props.modalFunction}
                  project={project}
                  setProject={setProject}
                  // childData={handleDataFromChild}
                  // translation1={fetchAddTask[2]?.translation}
                  // translation2={fetchAddTask[11]?.translation}
                  // translation3={fetchAddTask[17]?.translation}
                  // translation4={fetchAddTask[41]?.translation}
                />

                {/* Dependencies */}
                <Dependency
                  translation1={tt("Dependencies")}
                  translation2={tt("Link a Task..")}
                  translation3={tt("Waiting on")}
                  translation4={tt("Search tasks")}
                  showDependencyDrop={showDependencyDrop}
                  dependenciesRef={dependenciesRef}
                  allTasks={allTasks}
                  dependencyList={dependencyList}
                  setDependencyList={setDependencyList}
                  setChangeComp={setChangeComp}
                  setShowDependencyDrop={setShowDependencyDrop}
                  setTaskId={props.setTaskid}
                  taskId={props.taskid}
                />

                {/* Checklist */}
                <Checklist
                  translation1={tt("Checklist")}
                  translation2={tt("Add a checklist...")}
                  fetchAddTask={fetchAddTask}
                  setShowAddItem={setShowAddItem}
                  showAddItem={showAddItem}
                  inputRef={inputRef}
                  checklist={checklist}
                  percent={percent}
                  updateChecklist={updateChecklist}
                  setChecklist={setChecklist}
                  setTotalCheck={setTotalCheck}
                  deleteChecklist={deleteChecklist}
                  inputRef2={inputRef2}
                  checklistTitle={checklistTitle}
                  handleAddChecklist={handleAddChecklist}
                  setChecklistTitle={setChecklistTitle}
                  setChangeComp={setChangeComp}
                  rowClickRef={rowClickRef}
                />

                {/* BOM Part */}
                <TaskProductsPart
                  setChangeComp={setChangeComp}
                  taskId={props.taskid}
                  projectId={project?.projectid}
                  setTaskId={props.setTaskid}
                  modalFunction={props.modalFunction}
                  onProductsChange={handleProductsChange}
                  // childData={handleDataFromChild}
                  // onEquipmentsChange={setActivityEquipments}
                  // onActivityDataChange={setActivityData}
                  // translation1={fetchAddTask[126]?.translation}
                  // translation2={fetchAddTask[127]?.translation}
                  // translation3={fetchAddTask[128]?.translation}
                  // translation4={fetchAddTask[129]?.translation}
                  // translation5={fetchAddTask[130]?.translation}
                  // translation6={fetchAddTask[131]?.translation}
                />

                {/* Activity */}
                <Activity
                  setChangeComp={setChangeComp}
                  taskId={props.taskid}
                  projectId={project?.projectid}
                  setTaskId={props.setTaskid}
                  modalFunction={props.modalFunction}
                  attachmentsFetchData={attachmentsFetchData}
                  childData={handleDataFromChild}
                  onEquipmentsChange={setActivityEquipments}
                  onActivityDataChange={setActivityData}
                  // translation1={fetchAddTask[126]?.translation}
                  // translation2={fetchAddTask[127]?.translation}
                  // translation3={fetchAddTask[128]?.translation}
                  // translation4={fetchAddTask[129]?.translation}
                  // translation5={fetchAddTask[130]?.translation}
                  // translation6={fetchAddTask[131]?.translation}
                />

                {/* comment */}
                <div
                  className="task-modal-dependencies-new-box"
                  style={{ marginTop: "2rem" }}
                >
                  <div className="task-modal-dependencies-box-1 frcb">
                    <p className="mb-0">{tt("Comments")}</p>
                    {visibleCommentCount > 5 ? (
                      <p
                        className="mb-0"
                        onClick={() => {
                          setShowMoreComm((current) => !current);
                        }}
                      >
                        {showMoreComm
                          ? `${tt("Show less")}`
                          : `${tt("Show more...")}`}{" "}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div
                  className={
                    props.modalFunction === "add"
                      ? "row commentarea"
                      : "row commentarea"
                  }
                  style={{ padding: "0 2rem" }}
                >
                  <div className="px-0 my-1 col-1 d-flex">
                    <button
                      className="teambtn comment-abbre-pop"
                      type="button"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      style={{
                        marginTop: "10px",
                        textTransform: "uppercase",
                        fontSize: "16px)",
                        width: " 37px",
                        height: "37px",
                        borderRadius: "50%",
                        border: "none",
                      }}
                    >
                      {userimag ? (
                        <div>
                          <img
                            className=""
                            src={userimag}
                            alt=""
                            style={{
                              width: " 37px",
                              height: "37px",
                              borderRadius: "50%",
                              border: "none",
                              marginLeft: "-6px",
                              marginTop: "-1px",
                              objectFit: "cover",
                            }}
                          />
                        </div>
                      ) : (
                        <div>
                          {userlastname
                            ? userfirstname[0]?.toUpperCase() +
                              "" +
                              userlastname[0]?.toUpperCase()
                            : userfirstname.slice(0, 2).toUpperCase()}
                        </div>
                      )}
                    </button>
                  </div>
                  <div
                    className="p-0 col-11"
                    id="addTaskComntBox"
                    style={{ minHeight: "150px", height: "155px" }}
                  >
                    <Editor
                      placeholder={tt("Write a comment")}
                      editorState={editorState}
                      onEditorStateChange={changeApplied}
                      handlePastedText={handleCommentPastedText}
                      wrapperClassName="wrapper-class ms-1"
                      editorClassName="task-comment-text-pop text-black"
                      toolbarClassName="toolbar-bottom-absolute"
                      toolbarHidden={true}
                      mention={{
                        separator: " ",
                        trigger: "@",
                        suggestions: activeuser.map((x) => ({
                          text: `${x.firstname} ${x.lastname}`,
                          value: `${x.firstname} ${x.lastname}`,
                          url: x.userid,
                        })),
                      }}
                    />
                    {showDropPeopleComm && (
                      <div
                        className="drop-down-plus-pop at_the_rate"
                        id="drop-down-plus"
                      >
                        <div className="search-div-people">
                          <FiSearch
                            style={{
                              marginRight: "6px",
                              marginBottom: "3px",
                            }}
                          />
                          <input
                            type="text"
                            style={
                              searchPeople
                                ? { opacity: "100%" }
                                : { opacity: "50%" }
                            }
                            className="search-people-input"
                            placeholder={tt("search")}
                            value={searchPeople}
                            onChange={(e) => {
                              setChangeComp(e.target.value);
                              setSearchPeople(e.target.value);
                            }}
                          />
                        </div>

                        {activeuser?.map((people, index) => {
                          return (
                            <div
                              key={index}
                              className="peoples-flex"
                              onClick={() => {
                                selectedUser(people);
                              }}
                            >
                              <p style={{ marginBottom: "0" }}>
                                {people?.firstname} {people?.lastname}
                              </p>
                            </div>
                          );
                        })}
                      </div>
                    )}

                    <div
                      role={"button"}
                      className=" position-relative"
                      style={{ left: "77%", bottom: "25%" }}
                    >
                      <p className="mb-0">
                        <span
                          className="ps-1 ms-xxl-2"
                          style={{
                            display: "grid",
                            alignItems: "center",
                            gridTemplateColumns: "1fr 1fr 16fr",
                          }}
                        >
                          <div
                            style={{
                              position: "relative",
                              display: "inline-block",
                              marginRight: "5px",
                            }}
                          >
                            <img
                              alt="emoji"
                              src={Icon2}
                              style={{
                                cursor: "pointer",
                                width: "20px",
                                marginBottom: "3px",
                              }}
                              onClick={() =>
                                setShowEmojiPicker(!showEmojiPicker)
                              }
                            />
                            {showEmojiPicker && (
                              <div
                                ref={emojiPickerRef}
                                className="emoji-picker-style"
                                style={{ left: "-256px" }}
                              >
                                <Picker
                                  data={data}
                                  onEmojiSelect={(e) => {
                                    const contentState = Modifier.replaceText(
                                      editorState.getCurrentContent(),
                                      editorState.getSelection(),
                                      e.native,
                                      editorState.getCurrentInlineStyle(),
                                    );
                                    setEditorState(
                                      EditorState.push(
                                        editorState,
                                        contentState,
                                        "insert-characters",
                                      ),
                                    );
                                  }}
                                />
                              </div>
                            )}
                          </div>
                          <DocumentUploaderWithProgress
                            onUploaded={(data) => {
                              const uploadedFiles = Array.isArray(data)
                                ? data
                                : [data].filter(Boolean);
                              const names = uploadedFiles.map(
                                (item) => item?.name,
                              );
                              const links = uploadedFiles
                                .map((item) => item?.link)
                                .filter(Boolean);

                              setUploadedFileName(names.join(", "));
                              setAttachmentUrl(links);
                              setChangeComp(uploadedFiles);
                              props.handleFileChange?.({
                                name: names.join(", "),
                                link: links,
                              });
                            }}
                          >
                            <label>
                              <i
                                className="bi bi-paperclip attach-icon-pop mt-1"
                                style={{ color: "#bfbfbf" }}
                              ></i>
                            </label>
                          </DocumentUploaderWithProgress>

                          <img
                            style={{
                              marginBottom: "0px",
                              width: "20px",
                              opacity: "0.5",
                            }}
                            src={send}
                            className="me-5"
                            alt="leftarrow"
                            onClick={() => {
                              const hasAttachment = Array.isArray(attachmentUrl)
                                ? attachmentUrl.length > 0
                                : Boolean(attachmentUrl);

                              if (props.val.trim() !== "" || hasAttachment) {
                                if (
                                  props.modalFunction === "update" ||
                                  props.modalFunction === "Notification"
                                ) {
                                  props.handleAddComments(
                                    JSON.stringify(attachmentUrl),
                                  );
                                } else {
                                  const queuedComment = {
                                    attachments: JSON.stringify(attachmentUrl),
                                    message: props.val,
                                    timestamp: new Date().toISOString(),
                                    taggedUser: props.taggedUser,
                                    userid: userID,
                                    firstname: userfirstname,
                                    lastname: userlastname,
                                    imageurl:
                                      userimag && userimag !== "null"
                                        ? userimag
                                        : "",
                                    initials: userlastname
                                      ? (
                                          (userfirstname?.[0] || "") +
                                          (userlastname?.[0] || "")
                                        ).toUpperCase()
                                      : userfirstname
                                          ?.slice(0, 2)
                                          .toUpperCase(),
                                  };
                                  props.setShow([...props.show, queuedComment]);
                                  props.setLength(props.show.length + 1);
                                  props.setMaxComments([
                                    ...props.maxComments,
                                    queuedComment,
                                  ]);
                                }

                                props.setTaggedUser([]);
                                props.setMessage("");
                                props.setVal("");
                                props.setImgUrl?.("");
                                props.setAttachmentUrl?.("");
                                setEditorState(EditorState.createEmpty());
                              }
                              setUploadedFileName("");
                              setAttachmentUrl("");
                            }}
                          />
                        </span>
                      </p>
                    </div>
                  </div>
                  {isImage && uploadedFileName !== "" && (
                    <div className="uploadFileUrl">
                      <img src={attachmentUrl?.[0]} />
                    </div>
                  )}
                  <div
                    className="col-11 uploadedFileName pt-3"
                    style={{ paddingLeft: "3rem" }}
                  >
                    {uploadedFileName}
                  </div>
                </div>
                <div
                  style={{
                    marginBottom: props.showcmnt ? "0" : "0",
                    padding: "0 2rem",
                  }}
                >
                  {props.maxComments
                    ?.filter((item) => !item?.isdraft)
                    ?.slice(0, displayQuantity)
                    ?.map((item, index) => (
                      <div
                        key={index}
                        className="my-2 row"
                        style={{ marginBottom: "2rem" }}
                      >
                        <div className="px-0 my-1 col-1 pe-1 d-flex">
                          <button
                            className="teambtn"
                            type="button"
                            id="dropdownMenuButton"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                            style={{
                              // minWidth: "37px",
                              textTransform: "uppercase",
                              // fontSize: "16px",
                              fontSize: "16px",
                              // width: "3vw",
                              // height: "3vw",
                              width: "37px",
                              height: "37px",
                              borderRadius: "50%",
                              border: "none",
                            }}
                          >
                            {item.imageurl ? (
                              <div>
                                <img
                                  className=""
                                  src={item.imageurl}
                                  alt=""
                                  style={{
                                    width: " 37px",
                                    height: "37px",
                                    borderRadius: "50%",
                                    border: "none",
                                    marginLeft: "-6px",
                                    marginTop: "-1px",
                                    objectFit: "cover",
                                  }}
                                />
                              </div>
                            ) : (
                              <div>
                                {/* {item?.lastname
                                  ? item?.firstname[0]?.toUpperCase() +
                                    "" +
                                    item?.lastname[0]?.toUpperCase()
                                  : item?.firstname?.slice(0, 2).toUpperCase()} */}

                                {item.initials}
                              </div>
                            )}
                          </button>
                        </div>
                        <div
                          className="col-12 comment-box ms-1"
                          style={{
                            borderRadius: "10px",
                            border: "1px rgb(133, 133, 133) solid",
                            width: "87%",
                            // marginLeft: "12px",
                          }}
                        >
                          <div className="row">
                            <div className="pt-2 col-12 fntMessage text-start position-relative d-inline">
                              {/* {item.attachments === null ? (
                                ""
                              ) : ( */}
                              <span
                                id="comment_attach"
                                style={{
                                  fontSize: "14px",
                                  color: "#333333",
                                }}
                              >
                                {item.isdeleted ? (
                                  <span>This message was deleted</span>
                                ) : isJson(item.message) ? (
                                  <span
                                    dangerouslySetInnerHTML={{
                                      __html: getFormattedMessage(item.message),
                                    }}
                                  ></span>
                                ) : (
                                  // item.message
                                  <Linkify componentDecorator={linkDecorator}>
                                    {/* {parse(item.message)} */}
                                    {item.message}
                                  </Linkify>
                                )}
                                &nbsp;
                                {!item?.isdeleted &&
                                  item?.attachments &&
                                  Array.isArray(
                                    JSON.parse(item?.attachments),
                                  ) && (
                                    // <a
                                    //   href={item.attachments}
                                    //   target="_blank"
                                    //   className=" image-link"
                                    //   rel="noreferrer"
                                    // >
                                    //   <span className="blueTxt">
                                    //     {/* {item.attachments.split(".com/")[1]} */}

                                    //     {JSON.parse(item.attachments).map((x) => (
                                    //       <div key={x}>{x.split(".com/")[1]}</div>
                                    //     ))}
                                    //   </span>
                                    // </a>

                                    <div
                                      style={{
                                        lineHeight: "2",
                                        marginTop: "-25px",
                                      }}
                                    >
                                      {JSON.parse(item.attachments).map(
                                        (x, index) => (
                                          <a
                                            key={index}
                                            href={x}
                                            target="_blank"
                                            className="image-link"
                                            rel="noreferrer"
                                            style={{}}
                                          >
                                            <div className="blueTxt">
                                              {/* {x.split(".com/")[1]} */}
                                              {x.split("/").pop()}
                                            </div>
                                          </a>
                                        ),
                                      )}
                                    </div>
                                  )}
                              </span>
                              {/* )} */}
                            </div>
                            <div
                              className="mt- col-12 text-end dateTime fntdate"
                              style={{
                                display: "flex",
                                gap: "5px",
                                justifyContent: "end",
                              }}
                            >
                              <div
                                className="row pe-3 pb-2 ms-"
                                style={{
                                  display: "flex",
                                  marginBottom: "4px",
                                  marginTop: "3px",
                                  fontSize: "14px",
                                  justifyContent: "end",
                                }}
                              >
                                {!item?.isdeleted && (
                                  <>
                                    {/* {moment(item.timestamp).format(
                                      "DD.MM.YYYY,h:mm a",
                                    )} */}
                                    {formatDateTime(item.timestamp)}
                                  </>
                                )}
                                <div className="col-1 pointer">
                                  {userID === item.userid &&
                                    !item.isdeleted && (
                                      <img
                                        style={{
                                          width: "16px",
                                          opacity: "0.5",
                                        }}
                                        src={deleteIcon}
                                        className="addTaskMODLDlt"
                                        alt="dlt"
                                        onClick={() => {
                                          setDeleteCommOpen(true);
                                          setCommentDeleteID(item.commentid);
                                        }}
                                      />
                                    )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
                {/* lower comment section start */}
                {/* <div>
                  {props.show && props.enablecomm
                    ? props.show.map((item, index) => (
                      <div key={index} className="my-2 row" style={{ marginBottom: "2rem" }}>
                        <div className="px-0 my-1 col-1 pe-1 d-flex">
                          <button
                            style={{
                              border: "none",
                              borderRadius: "50%",
                              fontSize: "16px",
                            }}
                            className="teambtn"
                            type="button"
                            id="dropdownMenuButton"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            {userlastname
                              ? userfirstname[0]?.toUpperCase() +
                              "" +
                              userlastname[0]?.toUpperCase()
                              : userfirstname.slice(0, 2).toUpperCase()}
                          </button>
                        </div>

                        <div
                          className="col-11 comment-box ms-1"
                          style={{
                            borderRadius: "10px",
                            border: "1px rgb(133, 133, 133) solid",
                            width: "clamp(504px, 25.781vw, 25.781vw)",
                          }}
                        >
                          <div className="row">
                            <div className="pt-2 col-8 fntMessage text-start position-relative d-inline">
                              {item.attachments === null ? (
                                ""
                              ) : (
                                <span
                                  id="comment_attach"
                                  style={{
                                    fontSize: "14px",
                                    color: "#333333",
                                  }}
                                >
                                  {item.isdeleted ? (
                                   <span>This message was deleted</span>
                                  ) : (
                                  isJson(item.message) ? (
                                    <span
                                      dangerouslySetInnerHTML={{
                                        __html: getFormattedMessage(item.message),
                                      }}
                                    ></span>
                                  ) : (
                                    item.message
                                  )
                                  )}
                                  &nbsp;
                                {!item?.isdeleted && (
                                  <a
                                    href={item.attachments}
                                    target="_blank"
                                    className=" image-link"
                                    rel="noreferrer"
                                  >
                                    <span className="fw-bold taskclr">
                                      {item.attachments.split(".com/")[1]}
                                    </span>
                                  </a>
                                )}
                                </span>
                                // <span>
                                //   {item.message}&nbsp;
                                //   <a
                                //     href={item.attachments}
                                //     target="_blank"
                                //     className=" image-link"
                                //   >
                                //     <span className="fw-bold taskclr">
                                //       {item.attachments.split(".com/")[ 1 ]}
                                //     </span>
                                //   </a>
                                // </span>
                              )}
                            </div>
                            <div className="mt-2 col-4 text-end dateTime fntdate">
                              <div
                                className="row pe-1 ms-"
                                style={{
                                  marginBottom: "4px",
                                  marginTop: "30px",
                                  fontSize: "14px",
                                }}
                              >
                                {!item?.isdeleted && (
                                <>
                                {moment(item.timestamp).format("DD.MM.YYYY, h:mm a")}
                                </> 
                                )}
                                <div className="col-1 pointer">
                                  {userID === item.userid && !item.isdeleted &&(
                                   <img
                                   style={{width:"20px"}}
                                   src={deleteIcon}
                                   className="addTaskMODLDlt"
                                   alt="dlt"
                                   onClick={()=>{
                                   setDeleteCommOpen(true);
                                   setCommentDeleteID(item.commentid);
                                   }}
                                 />
                                )}
                                </div>  
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                    : ""}
                </div> */}
                {/* lower comment section end */}
              </div>
            </div>
            <div
              className="task-modal-right-main-pop"
              style={{
                backgroundColor:
                  priorityId === process.env.REACT_APP_TASK_PRIORITY_LOW
                    ? "#EAEAEA"
                    : priorityId === process.env.REACT_APP_TASK_PRIORITY_NORMAL
                      ? "#D2DCE9"
                      : priorityId ===
                          process.env.REACT_APP_TASK_PRIORITY_EXTREME
                        ? "#F76767"
                        : priorityId ===
                            process.env.REACT_APP_TASK_PRIORITY_HIGH
                          ? "#95A7C6"
                          : "#D2DCE9",
                width: "100%",
              }}
            >
              <div>
                <div className="displayFlexCss">
                  <p
                    className="margin-0-pop ms-16-bold-right-pop ms-4 ps-1"
                    style={{ marginTop: "0px", marginLeft: "10px" }}
                  >
                    {/* Start Date */}
                    {t("Start Date")}
                  </p>
                </div>
                <div
                  id="contact_calender"
                  className={
                    roleAccess === process.env.REACT_APP_IS_VIEWER
                      ? "pointerEvent"
                      : ""
                  }
                  style={{
                    display: "flex",
                    width: "94%",
                    color: "#333333",
                  }}
                >
                  <img
                    // className="task-card-calendar-pop"
                    className={
                      roleAccess === process.env.REACT_APP_IS_VIEWER
                        ? "pointerEvent task-card-calendar-pop"
                        : "task-card-calendar-pop"
                    }
                    style={{
                      position: "relative",
                      bottom: "21px",
                    }}
                    src={Calender}
                    alt=""
                    onClick={() => setCalendarIsOpen((p) => !p)}
                  />

                  <AppDatePicker
                    open={calendarIsOpen}
                    onOpenChange={(open) => setCalendarIsOpen(open)}
                    selected={startDate}
                    isError={dateError2}
                    error={setDateError2}
                    onChange={datePickerFunc2}
                    dateFormat="dd.MM.yyyy"
                    onSelect={(d, event) => event.preventDefault()}
                    placeholderText={"00.00.0000"}
                    className={"ps-3"}
                  />
                </div>
              </div>
              <div>
                <div className="displayFlexCss">
                  {/* <img className="task-card-calendar-pop" src={Calender} /> */}
                  <p
                    className="margin-0-pop ms-16-bold-right-pop ms-4 ps-1"
                    style={{ marginTop: "0px", marginLeft: "10px" }}
                  >
                    {tt("Due Date")}
                  </p>
                </div>
                <div
                  id="contact_calender"
                  className={
                    roleAccess === process.env.REACT_APP_IS_VIEWER
                      ? "pointerEvent"
                      : ""
                  }
                  style={{
                    display: "flex",
                    width: "94%",
                    color: "#333333",
                  }}
                >
                  <img
                    // className="task-card-calendar-pop"
                    className={
                      roleAccess === process.env.REACT_APP_IS_VIEWER
                        ? "pointerEvent task-card-calendar-pop"
                        : "task-card-calendar-pop"
                    }
                    style={{
                      position: "relative",
                      bottom: "21px",
                    }}
                    src={Calender}
                    alt=""
                    onClick={() => setCalendarIsOpen2((p) => !p)}
                  />

                  <AppDatePicker
                    open={calendarIsOpen2}
                    onOpenChange={(open) => setCalendarIsOpen2(open)}
                    selected={dueDate}
                    isError={dateError}
                    error={setDateError}
                    onChange={datePickerFunc}
                    dateFormat="dd.MM.yyyy"
                    onSelect={(d, event) => event.preventDefault()}
                    placeholderText={"00.00.0000"}
                    className={"ps-3"}
                  />
                </div>
              </div>
              {/* due time */}
              <div>
                <div className="displayFlexCss">
                  <img className="task-card-calendar-pop" src={Clock} alt="" />
                  <p
                    className="margin-0-pop ms-16-bold-right-pop "
                    style={{ marginTop: "0px", marginLeft: "10px" }}
                  >
                    {tt("Due Time")}
                  </p>
                </div>
                <div
                  className={
                    roleAccess === process.env.REACT_APP_IS_VIEWER
                      ? "pointerEvent due-time-text-pop"
                      : "due-time-text-pop"
                  }
                >
                  <input
                    type="number"
                    placeholder="00"
                    id="hoursInput"
                    style={{
                      width: "23px",
                      background: "transparent",
                      border: "none",
                      fontSize: "16px",
                      "-moz-appearance": "textfield",
                    }}
                    value={hours}
                    maxLength="2"
                    onKeyDown={handleHoursKeyDown}
                    onChange={handleHoursChange}
                  />
                  <span
                    style={{
                      fontSize: "16px",
                    }}
                  >
                    :
                  </span>
                  <input
                    placeholder="00"
                    type="number"
                    id="minutesInput"
                    maxLength="2"
                    style={{
                      width: "23px",
                      background: "transparent",
                      border: "none",
                      fontSize: "16px",
                      "-moz-appearance": "textfield",
                    }}
                    value={minutes}
                    onKeyDown={handleMinutesKeyDown}
                    onChange={handleMinutesChange}
                  />
                  <span style={{ fontSize: "16px" }}>H</span>
                </div>
              </div>
              <div>
                <div className="displayFlexCss">
                  {/* <AiOutlineBell className="responsive-check" /> */}
                  <img
                    alt=""
                    src={bell}
                    className="responsive-check bell-layout-pop"
                  />
                  <p
                    className="margin-0-pop ms-16-bold-right-pop"
                    style={{ marginTop: "0px", marginLeft: "9px" }}
                  >
                    {tt("Notification")}
                  </p>
                </div>
                <div
                  style={{ paddingRight: "19px" }}
                  className={
                    roleAccess === process.env.REACT_APP_IS_VIEWER
                      ? "pointerEvent notification-text-pop ps-1 ms-4"
                      : "notification-text-pop ps-1 ms-4"
                  }
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    <input
                      className=""
                      type="text"
                      style={{
                        // width: "clamp(47px,2.188vw,2.188vw)",
                        width:
                          nminutes === "15" ||
                          nminutes === "30" ||
                          nminutes === "1" ||
                          nminutes === "24"
                            ? "30px"
                            : "70px",
                        background: "transparent",
                        border: "none",
                        fontSize: "16px",
                      }}
                      value={nminutes}
                      onKeyDown={(e) => {
                        if (e.key === "Backspace") {
                          if (nminutes.length === 2) {
                            setChangeComp(e.key);
                            return setNMinutes(minutes[0]);
                          }
                        }
                      }}
                      onChange={(e) => {
                        setChangeComp(e.target.value);
                        if (nminutes.length >= 2) {
                          return;
                        } else {
                          setNMinutes(e.target.value);
                        }
                      }}
                    />
                    <p
                      className="margin-0-pop"
                      style={{
                        // marginLeft: "10px",
                        fontSize: "16px",
                        color: "#333333",
                        fontWeight: "500",
                      }}
                      onClick={() => setShowNotiDropDown(!showNotiDropDown)}
                    >
                      {notiTime}
                    </p>
                  </div>

                  <div
                    style={{
                      cursor: "pointer",
                      position: "relative",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      color: "black",
                    }}
                    ref={notificationDropdownRef}
                  >
                    <BsChevronDown
                      onClick={() => setShowNotiDropDown(!showNotiDropDown)}
                      className={`${
                        showNotiDropDown
                          ? "down-arrow-pop down-arrow-rotate bi-paperclip ms-4 ms-xxl-3"
                          : "down-arrow-pop bi-paperclip ms-4 ms-xxl-3"
                      }`}
                    />
                    {showNotiDropDown && (
                      <div
                        className="drop-down-noti drop_noti_layout"
                        style={{
                          minWidth: "182px",
                          padding: "5px 0",
                        }}
                      >
                        {notificationTimes.map((item, i) => {
                          const parts = item?.split(" ") || [];
                          const notifvalue = parts[0];
                          const notifunit = (parts[1] || "") + (parts[2] || "");
                          return (
                            <p
                              key={i}
                              className="margin-0-pop mapped-notification"
                              style={{
                                fontSize: "14px",
                                background:
                                  notifvalue === nminutes ? "#f0f0f0" : "",
                                padding: "5px 10px",
                              }}
                              onClick={() => {
                                setNotiTime(notifunit);
                                setNMinutes(notifvalue);
                                setShowNotiDropDown(false);
                                setChangeComp(item);
                              }}
                            >
                              {item}
                              {/* {notiTime + "" + nminutes} */}
                            </p>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </div>
                <span className="before-text-pop">{tt("Before due time")}</span>
              </div>
              {/* assignee */}
              <div className="pt-3" ref={assigneeDropdownRef}>
                <div
                  className="displayFlexCss"
                  onClick={() => {
                    setShowDropPeople(false);
                    setOpenAssigneeModal(false);
                    setSearchPeople("");
                  }}
                >
                  <img className="task-card-calendar1" src={user} alt="" />
                  <p
                    className="margin-0-pop ms-16-bold-right-pop"
                    style={{ marginTop: "0px", marginLeft: "11px" }}
                  >
                    {tt("Assign To")}
                  </p>
                </div>

                <div
                  className={
                    roleAccess === process.env.REACT_APP_IS_VIEWER
                      ? "pointerEvent"
                      : ""
                  }
                >
                  <div className="mt-2 me-2 assign_to_plus_pop">
                    {showDropPeople && props.isBasicMember && (
                      <div
                        className="drop-down-plus-pop"
                        id="drop-down-plus"
                        style={{ zIndex: "1", left: "-20%" }}
                      >
                        <div className="search-div-people">
                          <FiSearch
                            style={{
                              marginRight: "6px",
                              marginBottom: "3px",
                            }}
                          />
                          <input
                            type="text"
                            style={
                              searchPeople
                                ? { opacity: "100%" }
                                : { opacity: "50%" }
                            }
                            className="search-people-input"
                            placeholder={tt("search")}
                            value={searchPeople}
                            onChange={(e) => {
                              setChangeComp(e.target.value);
                              setSearchPeople(e.target.value);
                            }}
                          />
                        </div>

                        {activeuser?.map((people, index) => {
                          const isUserAssigned = selectedUsers.some(
                            (item) => item.assigneeid === people.userid,
                          );
                          return (
                            <div
                              key={index}
                              className={`peoples-flex ${
                                isUserAssigned
                                  ? "selectedAssignee"
                                  : "non-selectedAssignee"
                              }`}
                              onClick={() => {
                                setSelectedAssignee([
                                  ...selectedAssignee,
                                  people.userid,
                                ]);
                                setShowDropPeople(false);
                                setChangeComp(people.userid);
                                if (
                                  selectedUsers?.find((item) => {
                                    if (item.assigneeid === people.userid) {
                                      return true;
                                    } else {
                                      return false;
                                    }
                                  })
                                ) {
                                  let data = [...selectedUsers];
                                  data = data.filter((item) => {
                                    return item.assigneeid !== people.userid;
                                  });
                                  manualTaskAssigneeIdsRef.current.delete(
                                    people.userid,
                                  );
                                  selectedUsersRef.current = data;
                                  setSelectedUsers(data);

                                  setSelectedAssignee([]);
                                } else {
                                  const assigneeid = people.userid;
                                  const imageurl = people.imageurl;
                                  const type = people.type;
                                  const firstname = people.firstname;
                                  const lastname = people.lastname;
                                  const nextSelectedUsers = [
                                    ...selectedUsers,
                                    {
                                      assigneeid,
                                      imageurl,
                                      firstname,
                                      lastname,
                                      type,
                                    },
                                  ];

                                  if (
                                    !checklistAssigneeIdsRef.current.has(
                                      assigneeid,
                                    )
                                  ) {
                                    manualTaskAssigneeIdsRef.current.add(
                                      assigneeid,
                                    );
                                  }
                                  selectedUsersRef.current = nextSelectedUsers;
                                  setSelectedUsers(nextSelectedUsers);
                                  setShowDropPeople(false);
                                  setSelectedAssignee([
                                    ...selectedAssignee,
                                    people.userid,
                                  ]);
                                }
                              }}
                            >
                              {people.imageurl ? (
                                <img
                                  alt=""
                                  src={people.imageurl}
                                  style={{
                                    width: "50px",
                                    height: "50px",
                                    borderRadius: "100%",
                                    border:
                                      "2px solid var(--unnamed-color-00246a)",
                                  }}
                                />
                              ) : (
                                <div
                                  style={{
                                    backgroundColor: "#95A7C6",
                                    color: "#ffffff",
                                    width: "50px",
                                    height: "50px",
                                    borderRadius: "100%",
                                    border:
                                      "2px solid var(--unnamed-color-00246a)",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  {people?.lastname
                                    ? people?.firstname[0]?.toUpperCase() +
                                      "" +
                                      people?.lastname[0]?.toUpperCase()
                                    : people?.firstname
                                        ?.slice(0, 2)
                                        .toUpperCase()}
                                </div>
                              )}

                              <p
                                style={{
                                  marginBottom: "0",
                                  textAlign: "start",
                                  gap: "8px",
                                }}
                                className="assign-user"
                              >
                                {people?.firstname} {people?.lastname}
                              </p>
                            </div>
                          );
                        })}
                      </div>
                    )}

                    {selectedUsers
                      ?.filter((x) => x.type !== "team" && !Boolean(x.hide))
                      .map((item, index) => {
                        console.log("asc44 Data", item);
                        const isAssignedToChecklist =
                          checklistAssigneeIdsRef.current.has(
                            getAssigneeId(item),
                          );
                        return (
                          <React.Fragment key={index}>
                            <div
                              onClick={() =>
                                removeTaskAssigneeFromRightSide(item)
                              }
                              style={{
                                cursor: isAssignedToChecklist
                                  ? "not-allowed"
                                  : "pointer",
                              }}
                            >
                              <div
                                style={{
                                  opacity: isAssignedToChecklist ? 0.65 : 1,
                                  pointerEvents: isAssignedToChecklist
                                    ? "none"
                                    : "auto",
                                }}
                              >
                                {item.imageurl ? (
                                  <img
                                    src={item?.imageurl}
                                    className="orderIcon"
                                    style={{
                                      width: "56px",
                                      height: "56px",
                                      cursor: isAssignedToChecklist
                                        ? "not-allowed"
                                        : "pointer",
                                      borderRadius: "100%",
                                      marginLeft: "-25px",
                                      border: "0.2vw #ffffff solid ",
                                      objectFit: "cover",
                                    }}
                                    alt=""
                                  />
                                ) : (
                                  <div className="abbre-pop cursor-pointer">
                                    {item?.lastname
                                      ? item?.firstname[0]?.toUpperCase() +
                                        "" +
                                        item?.lastname[0]?.toUpperCase()
                                      : item?.firstname
                                          ?.slice(0, 2)
                                          .toUpperCase()}
                                  </div>
                                )}
                              </div>
                            </div>
                          </React.Fragment>
                        );
                      })}

                    <div
                      className="plus-design-pop"
                      onClick={() => {
                        setShowDropPeople(!showDropPeople);
                        setOpenAssigneeModal(!openAssigneeModal);
                        setSearchPeople("");
                      }}
                    >
                      <BsPlusLg
                        style={{
                          color: "#00246A",
                          fontSize: "2rem",
                        }}
                      />
                    </div>
                    {openAssigneeModal && !props.isBasicMember && (
                      <AssigneeModal
                        isBuildingBlock={props.isBuildingBlock}
                        modalOpen={openAssigneeModal}
                        modalHideEv={() => {
                          setOpenAssigneeModal(false);
                          dispatch(
                            UpdateTaskAssigee({
                              taskid: props.taskid,
                              taskassignee: Array.from(
                                new Set(
                                  selectedUsersRef.current?.map((user) =>
                                    getAssigneeId(user),
                                  ),
                                ),
                              ).map((id) => ({
                                assigneeid: id,
                              })),
                            }),
                          );
                        }}
                        selectedUsers={selectedUsers}
                        setSelectedUsers={(data) => {
                          onUpdateAssignee(data);
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
              {/* Equipments start */}
              {props.isBuildingBlock && (
                <div className="pt- pt-xxl-">
                  <div className="displayFlexCss">
                    <img
                      alt=""
                      src={proEquipmentsIcon}
                      style={{
                        width: "18px",
                        height: "20px",
                      }}
                    />
                    <p
                      className="margin-0-pop ms-16-bold-right-pop"
                      style={{ marginTop: "0px", marginLeft: "7px" }}
                    >
                      {/* Equipments */}
                      {t("Equipements")}
                    </p>

                    <img
                      onClick={() => setToggleEquipment(true)}
                      src={PlusIcon2}
                      className="card-plus-img ms-3"
                      alt="totalStock"
                    />
                  </div>
                  <div className="equipments ps-4 pt-2">
                    {toggleEquipment && (
                      <TaskEquipmentList
                        setToggleEquipment={toggleEquipmentFun}
                        selectedEquipments={displayedEquipments}
                        setSelectedEquipments={(equipments) =>
                          setSelectedEquipments(
                            equipments.filter(
                              (equipment) =>
                                selectedEquipments.some(
                                  (item) =>
                                    String(item.equipmentid) ===
                                    String(equipment.equipmentid),
                                ) ||
                                !activityEquipments.some(
                                  (item) =>
                                    String(item.equipmentid) ===
                                    String(equipment.equipmentid),
                                ),
                            ),
                          )
                        }
                      />
                    )}
                    {displayedEquipments.map((item) => {
                      const isActivityEquipment = activityEquipments.some(
                        (equipment) =>
                          String(equipment.equipmentid) ===
                          String(item.equipmentid),
                      );
                      return (
                        <div
                          key={item.equipmentid}
                          className="d-flex justify-content-between gap-1 ps-1 text-dark"
                        >
                          <p className="mb-0">{item.equipmentname}</p>
                          {!isActivityEquipment && (
                            <img
                              onClick={() => removeEquipment(item.equipmentid)}
                              src={deleteIcon}
                              className="card-plus-img me-4"
                              style={{ width: "14px" }}
                              alt="totalStock"
                            />
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
              {/* Equipments end */}
              {/* status */}
              <div className="pt- pt-xxl-">
                <div className="displayFlexCss">
                  <img
                    alt=""
                    src={statusicon}
                    style={{
                      width: "18px",
                      height: "20px",
                    }}
                  />
                  <p
                    className="margin-0-pop ms-16-bold-right-pop"
                    style={{ marginTop: "0px", marginLeft: "7px" }}
                  >
                    {tt("Status")}
                  </p>
                </div>

                <div
                  style={{ marginLeft: "30px", paddingRight: "19px" }}
                  ref={statusDropdownRef}
                >
                  <div
                    style={{
                      cursor: "pointer",
                      position: "relative",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <div
                      onClick={() => setShowStatusDrop(!showStatusDrop)}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                        color: "black",
                      }}
                    >
                      {/* <p className="margin-0-pop status-text-pop">{statusName}</p> */}
                      <p className="margin-0-pop status-text-pop">
                        {statusName === "To Do"
                          ? tt("To Do")
                          : statusName === "Progress"
                            ? tt("Progress")
                            : statusName === "Complete"
                              ? tt("Complete")
                              : statusName}
                      </p>
                      <BsChevronDown
                        style={{
                          marginTop: "4px",
                          fontSize: "1.2rem",
                          // height: "9px", width: "16px",
                        }}
                        className={`${
                          showStatusDrop
                            ? "down-arrow-pop down-arrow-rotate bi-paperclip"
                            : "down-arrow-pop bi-paperclip"
                        }`}
                      />
                    </div>
                    {showStatusDrop && (
                      <div
                        className="drop-down-noti drop_down_layout"
                        style={{
                          minWidth: "182px",
                          minHeight: "fit-content",
                          maxHeight: "120px",
                          overflow: "auto",
                          padding: "5px 0",
                          left: "-10px",
                        }}
                      >
                        {props?.statusList?.map((item, i) => {
                          return (
                            <p
                              key={i}
                              className="margin-0-pop mapped-notification"
                              style={{
                                fontSize: "14px",
                                background:
                                  statusName === item.statusName
                                    ? "#f0f0f0"
                                    : "",
                                padding: "5px 10px",
                              }}
                              onClick={() => {
                                setStatusId(item.statusId);
                                setStatusName(item.statusName);
                                setShowStatusDrop(false);
                                setChangeComp(item.statusId);
                                dispatch(
                                  ChangeStatus(props.taskid, item.statusId),
                                );
                              }}
                            >
                              {/* {item.statusName} */}
                              {item.statusName === "To Do"
                                ? tt("To Do")
                                : item.statusName === "Progress"
                                  ? tt("Progress")
                                  : item.statusName === "Complete"
                                    ? tt("Complete")
                                    : item.statusName}
                            </p>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {/* Section */}
              {props.showNewTaskSystem && sectionList.length !== 0 && (
                <div className="pt- pt-xxl-">
                  <div className="displayFlexCss">
                    <img
                      alt=""
                      src={layer}
                      style={{
                        width: "18px",
                        height: "20px",
                      }}
                    />
                    <p
                      className="margin-0-pop ms-16-bold-right-pop"
                      style={{ marginTop: "0px", marginLeft: "7px" }}
                    >
                      {/* Section */}
                      {t("Section")}
                    </p>
                  </div>

                  <div
                    style={{ marginLeft: "30px", paddingRight: "19px" }}
                    ref={sectionDropdownRef}
                  >
                    <div
                      style={{
                        cursor: "pointer",
                        position: "relative",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <div
                        onClick={() => setShowSectionDrop(!showSectionDrop)}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          width: "100%",
                          color: "black",
                        }}
                      >
                        <p className="margin-0-pop status-text-pop">
                          {sectionName}
                        </p>
                        <BsChevronDown
                          style={{
                            marginTop: "4px",
                            fontSize: "1.2rem",
                            // height: "9px", width: "16px",
                          }}
                          className={`${
                            showSectionDrop
                              ? "down-arrow-pop down-arrow-rotate bi-paperclip"
                              : "down-arrow-pop bi-paperclip"
                          }`}
                        />
                      </div>
                      {showSectionDrop && (
                        <div
                          className="drop-down-noti drop_down_layout"
                          style={{
                            minWidth: "182px",
                            minHeight: "fit-content",
                            maxHeight: "120px",
                            overflow: "auto",
                            padding: "5px 0",
                            left: "-10px",
                          }}
                        >
                          {sectionList?.map((item, i) => {
                            return (
                              <p
                                key={i}
                                className="margin-0-pop mapped-notification"
                                style={{
                                  fontSize: "14px",
                                  background:
                                    sectionName === item?.sectionName
                                      ? "#f0f0f0"
                                      : "",
                                  padding: "5px 10px",
                                }}
                                onClick={() => {
                                  setSectionId(item?.sectionId);
                                  setSectionName(item?.sectionName);
                                  setShowSectionDrop(false);
                                  setChangeComp(item?.sectionId);
                                }}
                              >
                                {item?.sectionName}
                              </p>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
              {companyId !== "28830f30-b321-4662-a576-f23451677742" &&
                props.isBuildingBlock && (
                  <div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "30px",
                        position: "relative",
                      }}
                    >
                      <div className="displayFlexCss">
                        <img
                          alt=""
                          src={invoiceBlack}
                          style={{
                            width: "18px",
                            height: "20px",
                          }}
                        />
                        <p
                          className="margin-0-pop ms-16-bold-right-pop"
                          style={{ marginTop: "0px", marginLeft: "7px" }}
                        >
                          {/* Request PO */}
                          {t("Request PO")}
                        </p>
                      </div>
                      <div className="task-grid-element-2">
                        <article
                          className="task-slider"
                          style={{
                            backgroundColor: voucherCreated && "#00246A",
                          }}
                          onClick={() => {
                            if (statusName == "Complete") {
                              if (voucherCreated) {
                                PerformaNotification(voucher);
                              } else {
                                setTaskComplete(true);
                                setOpenInvoice(true);
                                getCompletedTaskByProject();
                              }
                            } else {
                              setOpenInvoice(true);
                            }
                          }}
                        >
                          <article
                            className="task-slider-knob"
                            style={{ left: voucherCreated && "46%" }}
                          ></article>
                        </article>
                      </div>
                    </div>
                    {voucherCreated && (
                      <lable className="voucher-label">
                        Request{" "}
                        <label
                          className="voucherId"
                          onClick={() => {
                            // handleEditPO(voucher.voucherId);
                            // setChangeComp(voucher.voucherId);
                          }}
                        >
                          {voucher.requestId}
                        </label>
                      </lable>
                    )}

                    {openInvoice && taskComplete && (
                      <div className="invoice-popup">
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                          }}
                        >
                          <p className="ps-2" style={{ fontWeight: "bolder" }}>
                            {/* Build PO */}
                            {tt("Build PO")}
                          </p>
                          <img
                            alt=""
                            src={xcircle3}
                            style={{
                              width: "22px",
                              height: "22px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setOpenInvoice(false);
                              setAddWorkPopup(false);
                              setChangeComp(false);
                            }}
                          />
                        </div>
                        <div
                          style={{
                            display: "flex",
                            gap: "5px",
                            alignItems: "center",
                          }}
                        >
                          <Checkbox
                            icon={<CircleOutlinedIcon fontSize="small" />}
                            checkedIcon={
                              <CircleIcon
                                className="circleIcon-color"
                                fontSize="small"
                              />
                            }
                            checked={addHours}
                            onChange={handleAddHoursChange}
                          />
                          <p className="mb-1">
                            {/* Hours tracked by co-workers */}
                            {tt("Hours tracked by co-workers")}
                          </p>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            gap: "5px",
                            alignItems: "center",
                          }}
                        >
                          <Checkbox
                            icon={<CircleOutlinedIcon fontSize="small" />}
                            checkedIcon={
                              <CircleIcon
                                className="circleIcon-color"
                                fontSize="small"
                              />
                            }
                            checked={equipment}
                            onChange={handleEquipmentChange}
                          />
                          <p className="mb-1">
                            {/* Equipment Used */}
                            {tt("Equipment Used")}
                          </p>
                        </div>
                        <div
                          className="ps-1 pt-1"
                          style={{
                            display: "flex",
                            gap: "5px",
                            paddingLeft: "8px",
                            alignItems: "center",
                          }}
                        >
                          <img
                            src={PlusIcon2}
                            alt=""
                            className="pls-btn m-2 pointer"
                            onClick={() => {
                              setAddWorkPopup(true);
                            }}
                          />
                          <p className="mb-1">
                            {/* Add another work to this PO */}
                            {tt(" Add another work to this PO")}
                          </p>
                        </div>
                        <div style={{ maxHeight: "115px", overflowY: "auto" }}>
                          {selectedTask?.map((task) => (
                            <div
                              className="accordian-summary-heading-div"
                              style={{
                                display: "flex",
                                gap: "5px",
                                paddingLeft: "40px",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <p style={{ margin: "0" }}>{task.taskName}</p>
                              <img
                                alt=""
                                src={trash}
                                style={{ cursor: "pointer" }}
                                onClick={() => handleDeleteTask(task.taskId)}
                              />
                            </div>
                          ))}
                        </div>

                        <button
                          className="build-po-btn mt-4 m-auto"
                          onClick={() => {
                            handleBuildPO();
                            setChangeComp(true);
                          }}
                        >
                          {/* Build PO */}
                          {tt("Build PO")}
                        </button>
                      </div>
                    )}

                    {openInvoice && !taskComplete && (
                      <div className="invoice-popup">
                        <p style={{ textAlign: "center" }}>
                          {/* To Make the PO, the task need top be completed. */}
                          {tt("To Make the PO, the task need top be completed")}
                        </p>
                        <p style={{ textAlign: "center" }}>
                          <strong>
                            {/* Would You Like To Turn the Task to Complete? */}
                            {tt("Would You Like To Turn the Task to Complete?")}
                          </strong>
                        </p>

                        <div className="row">
                          <div className="col-6 pe-1">
                            <button
                              className="po-btn-cancel m-auto"
                              onClick={() => {
                                closeModal();
                              }}
                            >
                              {/* Cancel */}
                              {tt("Cancel")}
                            </button>
                          </div>
                          <div className="col-6 ps-1">
                            <button
                              className="po-btn-complete m-auto"
                              onClick={() => {
                                changeTaskStatusToComplete();
                                setChangeComp(true);
                              }}
                            >
                              {/* Complete */}
                              {tt("Complete")}
                            </button>
                          </div>
                        </div>
                      </div>
                    )}

                    {addWorkPopup && (
                      <div className="project-popup">
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            background: "#3B45581A",
                            padding: "10px",
                            alignItems: "center",
                            borderRadius: "8px",
                          }}
                        >
                          <p style={{ fontWeight: "bolder", margin: "0" }}>
                            {/* Work Completed */}
                            {tt("Work Completed")}
                          </p>
                          <div>
                            <input
                              className="project-search ps-2"
                              type="text"
                              placeholder="Search..."
                              value={workCompletedSearch}
                              onChange={(e) =>
                                setWorkCompletedSearch(e.target.value)
                              }
                            />
                          </div>
                          <img
                            alt=""
                            src={x}
                            style={{
                              width: "22px",
                              height: "22px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setAddWorkPopup(false);
                            }}
                          />
                        </div>
                        <div style={{ padding: "10px", overflowY: "auto" }}>
                          {completedTask
                            ?.filter((item) =>
                              item.taskName
                                ?.toLowerCase()
                                .includes(workCompletedSearch.toLowerCase()),
                            )
                            ?.map((task) => (
                              <p
                                className="ulterDrop mb-0"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  const isTaskAlreadySelected =
                                    selectedTask.some(
                                      (selectedTask) =>
                                        selectedTask.id === task.id,
                                    );
                                  if (!isTaskAlreadySelected) {
                                    setSelectedTask((prevSelectedTask) => [
                                      ...prevSelectedTask,
                                      task,
                                    ]);
                                  }
                                  // setAddWorkPopup(false);
                                }}
                              >
                                {task.taskName}
                              </p>
                            ))}
                        </div>
                      </div>
                    )}
                  </div>
                )}

              {/* Make invoice */}
              {props.isBuildingBlock && (
                <div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "30px",
                      position: "relative",
                    }}
                  >
                    <div className="displayFlexCss">
                      <img
                        alt=""
                        src={invoiceBlack}
                        style={{
                          width: "18px",
                          height: "20px",
                        }}
                      />
                      <p
                        className="margin-0-pop ms-16-bold-right-pop"
                        style={{ marginTop: "0px", marginLeft: "7px" }}
                      >
                        {/* Make invoice */}
                        {t("Make invoice")}
                      </p>
                    </div>
                    <div className="task-grid-element-2">
                      <article
                        className="task-slider"
                        style={{
                          backgroundColor: invoiceCreated && "#00246A",
                        }}
                        onClick={() => {
                          if (statusName == "Complete") {
                            if (invoiceCreated) {
                              InvoiceNotification(invoiceCreated, invoiceCode);
                            } else {
                              setTaskComplete(true);
                              // setOpenInvoice(true);
                              getCompletedTaskByProject();
                              handleAddInvoice();
                            }
                          } else {
                            setOpenInvoice(true);
                          }
                        }}
                      >
                        <article
                          className="task-slider-knob"
                          style={{ left: invoiceCreated && "46%" }}
                        ></article>
                      </article>
                    </div>
                  </div>
                  {invoiceCreated === 1 && (
                    <lable className="voucher-label">
                      Invoice{" "}
                      <label
                        className="voucherId"
                        onClick={() => {
                          // handleEditPO(voucher.voucherId);
                          // setChangeComp(voucher.voucherId);
                        }}
                      >
                        {invoiceCode}
                      </label>
                    </lable>
                  )}

                  {openInvoice && taskComplete && (
                    <div className="invoice-popup">
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                        }}
                      >
                        <p className="ps-2" style={{ fontWeight: "bolder" }}>
                          {/* Build PO */}
                          {tt("Build PO")}
                        </p>
                        <img
                          alt=""
                          src={xcircle3}
                          style={{
                            width: "22px",
                            height: "22px",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            setOpenInvoice(false);
                            setAddWorkPopup(false);
                            setChangeComp(false);
                          }}
                        />
                      </div>
                      <div
                        style={{
                          display: "flex",
                          gap: "5px",
                          alignItems: "center",
                        }}
                      >
                        <Checkbox
                          icon={<CircleOutlinedIcon fontSize="small" />}
                          checkedIcon={
                            <CircleIcon
                              className="circleIcon-color"
                              fontSize="small"
                            />
                          }
                          checked={addHours}
                          onChange={handleAddHoursChange}
                        />
                        <p className="mb-1">
                          {/* Hours tracked by co-workers */}
                          {tt("Hours tracked by co-workers")}
                        </p>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          gap: "5px",
                          alignItems: "center",
                        }}
                      >
                        <Checkbox
                          icon={<CircleOutlinedIcon fontSize="small" />}
                          checkedIcon={
                            <CircleIcon
                              className="circleIcon-color"
                              fontSize="small"
                            />
                          }
                          checked={equipment}
                          onChange={handleEquipmentChange}
                        />
                        <p className="mb-1">
                          {/* Equipment Used */}
                          {tt("Equipment Used")}
                        </p>
                      </div>
                      <div
                        className="ps-1 pt-1"
                        style={{
                          display: "flex",
                          gap: "5px",
                          paddingLeft: "8px",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src={PlusIcon2}
                          alt=""
                          className="pls-btn m-2 pointer"
                          onClick={() => {
                            setAddWorkPopup(true);
                          }}
                        />
                        <p className="mb-1">
                          {/* Add another work to this PO */}
                          {tt(" Add another work to this PO")}
                        </p>
                      </div>
                      <div style={{ maxHeight: "115px", overflowY: "auto" }}>
                        {selectedTask?.map((task) => (
                          <div
                            className="accordian-summary-heading-div"
                            style={{
                              display: "flex",
                              gap: "5px",
                              paddingLeft: "40px",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <p style={{ margin: "0" }}>{task.taskName}</p>
                            <img
                              alt=""
                              src={trash}
                              style={{ cursor: "pointer" }}
                              onClick={() => handleDeleteTask(task.taskId)}
                            />
                          </div>
                        ))}
                      </div>

                      <button
                        className="build-po-btn mt-4 m-auto"
                        onClick={() => {
                          handleBuildPO();
                          setChangeComp(true);
                        }}
                      >
                        {/* Build PO */}
                        {tt("Build PO")}
                      </button>
                    </div>
                  )}

                  {openInvoice && !taskComplete && (
                    <div className="invoice-popup">
                      <p style={{ textAlign: "center" }}>
                        {/* To Make the Invoice, the task need top be completed. */}
                        {tt(
                          "To Make the Invoice, the task need top be completed",
                        )}
                      </p>
                      <p style={{ textAlign: "center" }}>
                        <strong>
                          {/* Would You Like To Turn the Task to Complete? */}
                          {tt("Would You Like To Turn the Task to Complete?")}
                        </strong>
                      </p>

                      <div className="row">
                        <div className="col-6 pe-1">
                          <button
                            className="po-btn-cancel m-auto"
                            onClick={() => {
                              closeModal();
                            }}
                          >
                            {/* Cancel */}
                            {tt("Cancel")}
                          </button>
                        </div>
                        <div className="col-6 ps-1">
                          <button
                            className="po-btn-complete m-auto"
                            onClick={() => {
                              changeTaskStatusToComplete();
                              setChangeComp(true);
                            }}
                          >
                            {/* Complete */}
                            {tt("Complete")}
                          </button>
                        </div>
                      </div>
                    </div>
                  )}

                  {addWorkPopup && (
                    <div className="project-popup">
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          background: "#3B45581A",
                          padding: "10px",
                          alignItems: "center",
                          borderRadius: "8px",
                        }}
                      >
                        <p style={{ fontWeight: "bolder", margin: "0" }}>
                          {/* Work Completed */}
                          {tt("Work Completed")}
                        </p>
                        <div>
                          <input
                            className="project-search ps-2"
                            type="text"
                            placeholder="Search..."
                            value={workCompletedSearch}
                            onChange={(e) =>
                              setWorkCompletedSearch(e.target.value)
                            }
                          />
                        </div>
                        <img
                          alt=""
                          src={x}
                          style={{
                            width: "22px",
                            height: "22px",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            setAddWorkPopup(false);
                          }}
                        />
                      </div>
                      <div style={{ padding: "10px", overflowY: "auto" }}>
                        {completedTask
                          ?.filter((item) =>
                            item.taskName
                              ?.toLowerCase()
                              .includes(workCompletedSearch.toLowerCase()),
                          )
                          ?.map((task) => (
                            <p
                              className="ulterDrop mb-0"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                const isTaskAlreadySelected = selectedTask.some(
                                  (selectedTask) => selectedTask.id === task.id,
                                );
                                if (!isTaskAlreadySelected) {
                                  setSelectedTask((prevSelectedTask) => [
                                    ...prevSelectedTask,
                                    task,
                                  ]);
                                }
                                // setAddWorkPopup(false);
                              }}
                            >
                              {task.taskName}
                            </p>
                          ))}
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/* priority */}
              <div>
                <div className="displayFlexCss">
                  <img
                    alt=""
                    className=""
                    style={{
                      width: "18px",
                      height: "20px",
                    }}
                    src={PriorityIcon}
                  />
                  <p
                    className="margin-0-pop ms-16-bold-right-pop"
                    style={{ marginTop: "0px", marginLeft: "7px" }}
                  >
                    {tt("Priority")}
                  </p>
                </div>
                <div
                  style={{ marginLeft: "30px", paddingRight: "19px" }}
                  ref={priorityDropdownRef}
                >
                  <div
                    style={{
                      cursor: "pointer",
                      position: "relative",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                        justifyContent: "space-between",
                        color: "black",
                      }}
                      onClick={() => setShowPriorityDrop(!showPriorityDrop)}
                    >
                      <p
                        className="margin-0-pop priority-text-pop"
                        style={{ cursor: "pointer" }}
                        onClick={() => setShowPriorityDrop(!showPriorityDrop)}
                      >
                        {priorityName}
                      </p>
                      <BsChevronDown
                        onClick={() => setShowPriorityDrop(!showPriorityDrop)}
                        style={{ marginLeft: "40px" }}
                        className={`mapped-notification ${
                          showPriorityDrop
                            ? "down-arrow-pop down-arrow-rotate bi-paperclip"
                            : "down-arrow-pop bi-paperclip"
                        }`}
                      />
                    </div>
                    {showPriorityDrop && (
                      <div
                        className="drop-down-noti"
                        style={{
                          minWidth: "182px",
                          minHeight: "fit-content",
                          maxHeight: "120px",
                          overflow: "auto",
                          padding: "5px 0",
                          left: "-10px",
                        }}
                      >
                        {priorityData?.map((item, i) => {
                          return (
                            <p
                              key={i}
                              className="margin-0-pop mapped-notification"
                              style={{
                                background:
                                  item.name === priorityName ? "#f0f0f0" : "",
                                fontSize: "14px",
                                padding: "5px 10px",
                              }}
                              onClick={() => {
                                setPriorityId(item.id);
                                setPriorityName(item.name);
                                setShowPriorityDrop(false);
                                setChangeComp(item.name);
                              }}
                            >
                              {item.name}
                            </p>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {fetchAppSideNavOptions &&
                Array.isArray(fetchAppSideNavOptions) &&
                fetchAppSideNavOptions.every(
                  (item) => item.packageName !== "Basic",
                ) && (
                  <div>
                    <div className="displayFlexCss">
                      <img
                        className=""
                        src={Timer}
                        alt=""
                        style={{
                          width: "18px",
                          height: "20px",
                        }}
                      />
                      <p
                        className="margin-0 ms-16-bold"
                        style={{ marginTop: "0px", marginLeft: "7px" }}
                      >
                        {/* Hours Estimation */}
                        {t("Hours Estimation")}
                      </p>
                    </div>
                    <div className="pt-2 d-flex gap-3 ps-1">
                      <div style={{ fontSize: "12px" }}>
                        <p className="mb-0" style={{ color: "#707070" }}>
                          {/* Estimated */}
                          {t("Estimated")}
                        </p>
                        <div className="consumedtime ps-1">
                          <input
                            type="text"
                            value={estimatedTime}
                            className="consumedtime-input ps-1"
                            onChange={(e) => {
                              setEstimatedTime(e.target.value);
                            }}
                            onKeyDown={(e) => {
                              if (
                                e.key === "Enter" &&
                                props?.modalFunction === "update"
                              ) {
                                dispatch(
                                  UpdateEstimatedTime({
                                    taskid: props?.taskid,
                                    estimatedTime: e.target.value,
                                  }),
                                );
                              }
                            }}
                          />
                          <span>H</span>
                        </div>
                      </div>

                      <div style={{ fontSize: "12px" }}>
                        <p className="mb-0" style={{ color: "#707070" }}>
                          {/* Consumed */}
                          {t("Consumed")}
                        </p>
                        <div className="d-flex gap-1">
                          <p
                            className="consumedtime ps-1"
                            style={{ color: "#477400", width: "90px" }}
                          >
                            {`${total1} H`} : {`${total2} M`}
                          </p>
                          <p
                            className="consumedtime ps-1"
                            style={{
                              minWidth: "45px",
                              width: "auto",
                              color: "#707070",
                            }}
                          >
                            {Number(estimatedTime) > 0
                              ? `${(
                                  ((Number(total1) * 60 + Number(total2)) /
                                    (Number(estimatedTime) * 60)) *
                                  100
                                ).toFixed(1)}%`
                              : "0%"}

                            {/* {Number(estimatedTime) > 0
                              ? `${Math.round(
                                  ((Number(total1) * 60 + Number(total2)) /
                                    (Number(estimatedTime) * 60)) *
                                    100,
                                )}%`
                              : "0%"} */}
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* old code below */}
                    <div className="d-none">
                      <div className="displayFlexCss">
                        <img
                          className=""
                          src={Timer}
                          alt=""
                          style={{
                            width: "18px",
                            height: "20px",
                          }}
                        />
                        <p
                          className="margin-0 ms-16-bold"
                          style={{ marginTop: "0px", marginLeft: "7px" }}
                        >
                          {/* Track Time */}
                          {t("Track Time")}
                        </p>
                      </div>
                      <div className="time-track-flex d-block pe-5">
                        <div className="time-track-left-session">
                          <p className="time-track-csession-text">
                            {/* Current Session */}
                            {t("Current Session")}
                          </p>
                          <div
                            className="due-time-text-pop"
                            style={{ marginLeft: "0" }}
                          >
                            <p
                              style={{
                                width: "23px",
                                background: "transparent",
                                border: "none",
                                fontSize: "16px",
                              }}
                            >
                              {isTimerRunning ? session1 : "00"}
                            </p>
                            <span
                              style={{
                                fontSize: "16px",
                              }}
                            >
                              :
                            </span>
                            <p
                              style={{
                                width: "23px",
                                background: "transparent",
                                border: "none",
                                fontSize: "16px",
                              }}
                            >
                              {isTimerRunning ? session2 : "00"}
                            </p>
                            <span
                              style={{
                                fontSize: "16px",
                              }}
                            >
                              :
                            </span>
                            <p
                              style={{
                                width: "23px",
                                background: "transparent",
                                border: "none",
                                fontSize: "16px",
                              }}
                            >
                              {isTimerRunning ? session3 : "00"}
                            </p>
                          </div>
                        </div>
                        <article className="time-track-left-session">
                          <p className="time-track-csession-text">
                            {/* Total */}
                            {t("Total")}
                          </p>
                          <div
                            className="due-time-text-pop"
                            style={{ marginLeft: "0" }}
                          >
                            <p
                              style={{
                                // width: "23px",
                                width: "auto",
                                background: "transparent",
                                border: "none",
                                fontSize: "16px",
                              }}
                            >
                              {total1}
                            </p>
                            <span
                              style={{
                                fontSize: "16px",
                              }}
                            >
                              :
                            </span>
                            <p
                              style={{
                                // width: "23px",
                                width: "auto",
                                background: "transparent",
                                border: "none",
                                fontSize: "16px",
                              }}
                            >
                              {total2}
                            </p>
                          </div>
                        </article>
                      </div>
                      <div
                        className="track-time-box"
                        onClick={() => {
                          if (disableTracking) return;
                          if (isTimerRunning) {
                            setChangeComp("changed");
                            return dispatch(
                              UpdateTimeSession(
                                taskTrackingId,
                                moment().format("DD/MM/YYYY"),
                                moment().format("HH:mm:ss"),
                              ),
                            );
                          }
                          if (!props?.taskid) {
                            return handleGeneralNotification({
                              notificationType: "CUSTOM",
                              text: `Please add a task first`,
                            });
                          }
                          setChangeComp(true);
                          dispatch(
                            CheckIfTimeSessionStartOrNot(
                              project?.projectid,
                              props.taskid,
                              window.localStorage.getItem("userid"),
                              moment().format("DD/MM/YYYY"),
                              moment().format("HH:mm:ss"),
                            ),
                          );
                        }}
                        style={{
                          backgroundColor: isTimerRunning
                            ? "#95A7C6"
                            : "#fafafa",
                          cursor: disableTracking ? "default" : "pointer",
                        }}
                      >
                        <p
                          className="margin-0 start-text"
                          style={{
                            color: isTimerRunning && "#ffffff",
                            opacity: disableTracking ? "50%" : "100%",
                          }}
                        >
                          {isTimerRunning ? "Stop" : "Start"}
                        </p>
                        {isTimerRunning ? (
                          <img alt="" src={Stop} />
                        ) : (
                          <img
                            alt=""
                            src={disableTracking ? TriangleLight : Triangle}
                            style={{ marginTop: "5px" }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                )}
            </div>
            <div className="" style={{ display: "contents" }}>
              <div className="mb-4 task-modal-btn-grid-pop me-4 pe-1 pe-xxl-0">
                <p
                  className="task-modal-cancel-btn-pop2 ms-auto"
                  onClick={handelCancels}
                >
                  {tt("Cancel")}
                </p>

                <p
                  className="m-0 task-modal-cancel-btn1-pop"
                  style={{ width: "132px", height: "42px" }}
                  onClick={!disabled ? handleFunction : undefined}
                >
                  {props.modalFunction === "add" ? tt("Add ") : t("Change")}
                </p>
              </div>

              <div
                className="gap-color"
                style={{
                  backgroundColor:
                    priorityId === process.env.REACT_APP_TASK_PRIORITY_LOW
                      ? "#EAEAEA"
                      : priorityId ===
                          process.env.REACT_APP_TASK_PRIORITY_NORMAL
                        ? "#D2DCE9"
                        : priorityId ===
                            process.env.REACT_APP_TASK_PRIORITY_EXTREME
                          ? "#F76767"
                          : priorityId ===
                              process.env.REACT_APP_TASK_PRIORITY_HIGH
                            ? "#95A7C6"
                            : "#D2DCE9",
                  width: "100%",
                }}
              ></div>
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
};

export const PerformaNotification = (performa) => {
  toast.dismiss();
  toast(<PoNotificationMessage performa={performa} />, {
    icon: () => <img alt="" src={LogoSmall} width={35} />,
    className: "app-notification",
    data: {
      sound: new Audio(floatingSound),
    },
  });
};

const PoNotificationMessage = ({ performa }) => {
  if (performa && performa.requestId)
    return <div>Request {performa.requestId} Is Alredy Generated</div>;
  else return <div>Task is Not in Complete state</div>;
};

export const PerformaCreatedNotification = (voucher) => {
  toast.dismiss();
  toast(<PoCreatedNotificationMessage voucher={voucher} />, {
    icon: () => <img alt="" src={LogoSmall} width={35} />,
    className: "app-notification",
    data: {
      sound: new Audio(floatingSound),
    },
  });
};

const PoCreatedNotificationMessage = ({ voucher }) => {
  return <div>PO Request ID {voucher.requestId} was sent successfully.</div>;
};

// create invoice notification
export const InvoiceNotification = (invoce, invoiceCode) => {
  toast.dismiss();
  toast(
    <InvoiceNotificationMessage invoce={invoce} invoiceCode={invoiceCode} />,
    {
      icon: () => <img alt="" src={LogoSmall} width={35} />,
      className: "app-notification",
      data: {
        sound: new Audio(floatingSound),
      },
    },
  );
};

const InvoiceNotificationMessage = ({ invoce, invoiceCode }) => {
  if (invoce) return <div>Invoice {invoiceCode} Is Alredy Generated</div>;
  else return <div>Task is Not in Complete state</div>;
};

const InvoiceNotificationMessage2 = ({ invoce }) => {
  if (invoce && invoce.requestId)
    return <div>Invoice {invoce.requestId} Is Alredy Generated</div>;
  else return <div>Task is Not in Complete state</div>;
};

export default AddTaskModal;
